import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
import * as dcei_engine_expression_proto from './dcei_engine_expression_proto';
import * as dcei_engine_unit_proto from './dcei_engine_unit_proto';
class Validator_UnitWithinRange {
  get descriptor() {
    return Validator_UnitWithinRange.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRange = false;
    this._range = null;
    this._hasUnitCountRange = false;
    this._unitCountRange = null;
    this._hasDeprecatedFilter = false;
    this._filter = null;
    this._hasDistanceCheckMode = false;
    this._distanceCheckMode = null;
    this._hasDistanceExtendMode = false;
    this._distanceExtendMode = null;
    this._hasSearchFilter = false;
    this._searchFilter = null;
    this._targetValidators = [];
  }
  isEmpty() {
    if (this._hasRange) return false;
    if (this._hasUnitCountRange && !this._unitCountRange.isEmpty()) return false;
    if (this._hasDeprecatedFilter && !this._filter.isEmpty()) return false;
    if (this._hasDistanceCheckMode) return false;
    if (this._hasDistanceExtendMode) return false;
    if (this._hasSearchFilter && !this._searchFilter.isEmpty()) return false;
    if (this._targetValidators.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitWithinRange) {
      return value;
    }
    return Validator_UnitWithinRange.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitWithinRange();
    if (json.range != null) {
      result._hasRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.unitCountRange != null) {
      result._hasUnitCountRange = true;
      result._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromJson(json.unitCountRange);
    }
    if (json.filter != null) {
      result._hasDeprecatedFilter = true;
      result._filter = dcei_engine_effect_proto.OldSearchFilter.fromJson(json.filter);
    }
    if (json.distanceCheckMode != null) {
      result._hasDistanceCheckMode = true;
      result._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromJson(json.distanceCheckMode);
    }
    if (json.distanceExtendMode != null) {
      result._hasDistanceExtendMode = true;
      result._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromJson(json.distanceExtendMode);
    }
    if (json.searchFilter != null) {
      result._hasSearchFilter = true;
      result._searchFilter = dcei_engine_effect_proto.SearchFilter.fromJson(json.searchFilter);
    }
    result._targetValidators = JsonToList(json.targetValidators, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasUnitCountRange && !this._unitCountRange.isEmpty()) {
      result.unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.toJson(this._unitCountRange);
    }
    if (this._hasDeprecatedFilter && !this._filter.isEmpty()) {
      result.filter = dcei_engine_effect_proto.OldSearchFilter.toJson(this._filter);
    }
    if (this._hasDistanceCheckMode) {
      result.distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.toJson(this._distanceCheckMode);
    }
    if (this._hasDistanceExtendMode) {
      result.distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.toJson(this._distanceExtendMode);
    }
    if (this._hasSearchFilter && !this._searchFilter.isEmpty()) {
      result.searchFilter = dcei_engine_effect_proto.SearchFilter.toJson(this._searchFilter);
    }
    if (this._targetValidators.length > 0) {
      result.targetValidators = ArrayToJson(this._targetValidators, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasRange ? this._range : JsonToDouble.default;
  }
  get hasRange() {
    return this._hasRange;
  }
  setRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeInt}
   */
  get unitCountRange() {
    return this._hasUnitCountRange ? this._unitCountRange : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default;
  }
  get hasUnitCountRange() {
    return this._hasUnitCountRange;
  }
  setUnitCountRange(path, value) {
    return {type: 'SET', path: path.concat(['unitCountRange']), value: value.toJson()};
  }
  deleteUnitCountRange(path) {
    return {type: 'DELETE', path: path.concat(['unitCountRange'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.OldSearchFilter}
   */
  get filter() {
    return this._hasDeprecatedFilter ? this._filter : dcei_engine_effect_proto.OldSearchFilter.default;
  }
  get hasDeprecatedFilter() {
    return this._hasDeprecatedFilter;
  }
  setDeprecatedFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteDeprecatedFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {number}
   */
  get distanceCheckMode() {
    return this._hasDistanceCheckMode ? this._distanceCheckMode : dcei_engine_effect_proto.DistanceCheckModes.default;
  }
  get hasDistanceCheckMode() {
    return this._hasDistanceCheckMode;
  }
  setDistanceCheckMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceCheckMode']), value};
  }
  deleteDistanceCheckMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceCheckMode'])};
  }
  /**
   * @returns {number}
   */
  get distanceExtendMode() {
    return this._hasDistanceExtendMode ? this._distanceExtendMode : dcei_engine_effect_proto.DistanceExtendModes.default;
  }
  get hasDistanceExtendMode() {
    return this._hasDistanceExtendMode;
  }
  setDistanceExtendMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceExtendMode']), value};
  }
  deleteDistanceExtendMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceExtendMode'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.SearchFilter}
   */
  get searchFilter() {
    return this._hasSearchFilter ? this._searchFilter : dcei_engine_effect_proto.SearchFilter.default;
  }
  get hasSearchFilter() {
    return this._hasSearchFilter;
  }
  setSearchFilter(path, value) {
    return {type: 'SET', path: path.concat(['searchFilter']), value: value.toJson()};
  }
  deleteSearchFilter(path) {
    return {type: 'DELETE', path: path.concat(['searchFilter'])};
  }
  /**
   * @returns {string[]}
   */
  get targetValidators() {
    return this._targetValidators;
  }
  addTargetValidators(path, value) {
    return {type: 'ADD', path: path.concat(['targetValidators']), value};
  }
  setTargetValidators(path, value) {
    return {type: 'SET', path: path.concat(['targetValidators']), value: ArrayToJson(value, JsonToString)};
  }
  setTargetValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['targetValidators', key]), value};
  }
  deleteTargetValidators(path) {
    return {type: 'DELETE', path: path.concat(['targetValidators'])};
  }
  deleteTargetValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['targetValidators', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRange) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitCountRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasUnitCountRange = true;
              copy._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitCountRange) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasUnitCountRange = false;
              copy._unitCountRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitCountRange) {
            const copy = new Validator_UnitWithinRange(this);
            copy._hasUnitCountRange = true;
            copy._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitCountRange.apply(type, path.slice(1), value);
          if (newValue === this._unitCountRange) {
            return this;
          }
          const copy = new Validator_UnitWithinRange(this);
          copy._unitCountRange = copy._unitCountRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDeprecatedFilter = true;
              copy._filter = dcei_engine_effect_proto.OldSearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedFilter) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDeprecatedFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeprecatedFilter) {
            const copy = new Validator_UnitWithinRange(this);
            copy._hasDeprecatedFilter = true;
            copy._filter = dcei_engine_effect_proto.OldSearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new Validator_UnitWithinRange(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "distanceCheckMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDistanceCheckMode = true;
              copy._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceCheckMode) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDistanceCheckMode = false;
              copy._distanceCheckMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceExtendMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDistanceExtendMode = true;
              copy._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceExtendMode) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasDistanceExtendMode = false;
              copy._distanceExtendMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "searchFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._hasSearchFilter = true;
              copy._searchFilter = dcei_engine_effect_proto.SearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSearchFilter) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._hasSearchFilter = false;
              copy._searchFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSearchFilter) {
            const copy = new Validator_UnitWithinRange(this);
            copy._hasSearchFilter = true;
            copy._searchFilter = dcei_engine_effect_proto.SearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._searchFilter.apply(type, path.slice(1), value);
          if (newValue === this._searchFilter) {
            return this;
          }
          const copy = new Validator_UnitWithinRange(this);
          copy._searchFilter = copy._searchFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "targetValidators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._targetValidators = [];        for (let i of value) {
                copy._targetValidators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Validator_UnitWithinRange(this);
              copy._targetValidators = copy._targetValidators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._targetValidators.length === 0) {
                return this;
              }
              const copy = new Validator_UnitWithinRange(this);
              copy._targetValidators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._targetValidators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitWithinRange(this);
              copy._targetValidators = copy._targetValidators.slice();
              copy._targetValidators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Validator_UnitWithinRange(this);
              copy._targetValidators = copy._targetValidators.slice(0, path[1]).concat(copy._targetValidators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._targetValidators.length) {
            return this;
          }
          const oldValue = this._targetValidators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Validator_UnitWithinRange(this);
          copy._targetValidators = copy._targetValidators.slice();
          copy._targetValidators[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitWithinRange} other
   * @returns {Validator_UnitWithinRange}
   */
  merge(other) {
    const copy = new Validator_UnitWithinRange(this);
    if (other._hasRange) {
      copy._hasRange = true;
      copy._range = other._range;
    }
    if (other._hasUnitCountRange) {
      if (copy._hasUnitCountRange) {
        copy._unitCountRange = copy.unitCountRange.merge(other.unitCountRange);
      } else {
        copy._unitCountRange = other._unitCountRange;
      }
      copy._hasUnitCountRange = true;
    }
    if (other._hasDeprecatedFilter) {
      if (copy._hasDeprecatedFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasDeprecatedFilter = true;
    }
    if (other._hasDistanceCheckMode) {
      copy._hasDistanceCheckMode = true;
      copy._distanceCheckMode = other._distanceCheckMode;
    }
    if (other._hasDistanceExtendMode) {
      copy._hasDistanceExtendMode = true;
      copy._distanceExtendMode = other._distanceExtendMode;
    }
    if (other._hasSearchFilter) {
      if (copy._hasSearchFilter) {
        copy._searchFilter = copy.searchFilter.merge(other.searchFilter);
      } else {
        copy._searchFilter = other._searchFilter;
      }
      copy._hasSearchFilter = true;
    }
    copy._targetValidators = this._targetValidators.concat(other._targetValidators);
    return copy;
  }
}
Validator_UnitWithinRange.default = new Validator_UnitWithinRange();
class Validator_UnitWithinRange_Builder {
  constructor(value) {
    this._value = new Validator_UnitWithinRange(value);
  }
  build() {
    return new Validator_UnitWithinRange(this._value);
  }
  setRange(value) {
    this._value._hasRange = true;
    this._value._range = value;
    return this;
  }
  deleteRange() {
    this._value._hasRange = false;
    this._value._range = null;
    return this;
  }
  setUnitCountRange(value) {
    this._value._hasUnitCountRange = true;
    this._value._unitCountRange = value;
    return this;
  }
  deleteUnitCountRange() {
    this._value._hasUnitCountRange = false;
    this._value._unitCountRange = null;
    return this;
  }
  setDeprecatedFilter(value) {
    this._value._hasDeprecatedFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteDeprecatedFilter() {
    this._value._hasDeprecatedFilter = false;
    this._value._filter = null;
    return this;
  }
  setDistanceCheckMode(value) {
    this._value._hasDistanceCheckMode = true;
    this._value._distanceCheckMode = value;
    return this;
  }
  deleteDistanceCheckMode() {
    this._value._hasDistanceCheckMode = false;
    this._value._distanceCheckMode = null;
    return this;
  }
  setDistanceExtendMode(value) {
    this._value._hasDistanceExtendMode = true;
    this._value._distanceExtendMode = value;
    return this;
  }
  deleteDistanceExtendMode() {
    this._value._hasDistanceExtendMode = false;
    this._value._distanceExtendMode = null;
    return this;
  }
  setSearchFilter(value) {
    this._value._hasSearchFilter = true;
    this._value._searchFilter = value;
    return this;
  }
  deleteSearchFilter() {
    this._value._hasSearchFilter = false;
    this._value._searchFilter = null;
    return this;
  }
  addAllTargetValidators(values) {
    this._value._targetValidators = this._value._targetValidators.concat(values);
    return this;
  }
  addTargetValidators(value) {
    this._value._targetValidators = this._value._targetValidators.concat([value]);
    return this;
  }
  setTargetValidators(index, value) {
    this._value._targetValidators = this._value._targetValidators.concat();
    this._value._targetValidators[index] = value;
    return this;
  }
  clearTargetValidators() {
    this._value._targetValidators = [];
    return this;
  }
}
Validator_UnitWithinRange.Builder = Validator_UnitWithinRange_Builder;
class Validator_UnitWithinRange_WithParent {
  /**
   * @param {Validator_UnitWithinRange} value
   * @param {Validator_UnitWithinRange_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitWithinRange.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRange() {
    if (this._cachedHasRange === undefined) {
      if (this._value.hasRange) {
        this._cachedHasRange = true;
      } else {
        this._cachedHasRange = this._parent ? this._parent.hasRange : false;
      }
    }
    return this._cachedHasRange;
  }
  get range() {
    if (this._cachedRange === undefined) {
      if (this._value.hasRange) {
        this._cachedRange = this._value.range;
      } else {
        this._cachedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedRange;
  }
  get hasUnitCountRange() {
    if (this._cachedHasUnitCountRange === undefined) {
      if (this._value.hasUnitCountRange) {
        this._cachedHasUnitCountRange = true;
      } else {
        this._cachedHasUnitCountRange = this._parent ? this._parent.hasUnitCountRange : false;
      }
    }
    return this._cachedHasUnitCountRange;
  }
  get unitCountRange() {
    if (!this._cachedUnitCountRange) {
      if (this._value.hasUnitCountRange) {
        this._cachedUnitCountRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(this._value.unitCountRange, this._parent && this._parent.hasUnitCountRange ? this._parent.unitCountRange : null);
      } else {
        this._cachedUnitCountRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default, this._parent.unitCountRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent.default;
      }
    }
    return this._cachedUnitCountRange;
  }
  get hasDeprecatedFilter() {
    if (this._cachedHasDeprecatedFilter === undefined) {
      if (this._value.hasDeprecatedFilter) {
        this._cachedHasDeprecatedFilter = true;
      } else {
        this._cachedHasDeprecatedFilter = this._parent ? this._parent.hasDeprecatedFilter : false;
      }
    }
    return this._cachedHasDeprecatedFilter;
  }
  get filter() {
    if (!this._cachedDeprecatedFilter) {
      if (this._value.hasDeprecatedFilter) {
        this._cachedDeprecatedFilter = new dcei_engine_effect_proto.OldSearchFilter.WithParent(this._value.filter, this._parent && this._parent.hasDeprecatedFilter ? this._parent.filter : null);
      } else {
        this._cachedDeprecatedFilter = this._parent ? new dcei_engine_effect_proto.OldSearchFilter.WithParent(dcei_engine_effect_proto.OldSearchFilter.default, this._parent.filter) : dcei_engine_effect_proto.OldSearchFilter.WithParent.default;
      }
    }
    return this._cachedDeprecatedFilter;
  }
  get hasDistanceCheckMode() {
    if (this._cachedHasDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedHasDistanceCheckMode = true;
      } else {
        this._cachedHasDistanceCheckMode = this._parent ? this._parent.hasDistanceCheckMode : false;
      }
    }
    return this._cachedHasDistanceCheckMode;
  }
  get distanceCheckMode() {
    if (this._cachedDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedDistanceCheckMode = this._value.distanceCheckMode;
      } else {
        this._cachedDistanceCheckMode = this._parent ? this._parent.distanceCheckMode : this._value.distanceCheckMode;
      }
    }
    return this._cachedDistanceCheckMode;
  }
  get hasDistanceExtendMode() {
    if (this._cachedHasDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedHasDistanceExtendMode = true;
      } else {
        this._cachedHasDistanceExtendMode = this._parent ? this._parent.hasDistanceExtendMode : false;
      }
    }
    return this._cachedHasDistanceExtendMode;
  }
  get distanceExtendMode() {
    if (this._cachedDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedDistanceExtendMode = this._value.distanceExtendMode;
      } else {
        this._cachedDistanceExtendMode = this._parent ? this._parent.distanceExtendMode : this._value.distanceExtendMode;
      }
    }
    return this._cachedDistanceExtendMode;
  }
  get hasSearchFilter() {
    if (this._cachedHasSearchFilter === undefined) {
      if (this._value.hasSearchFilter) {
        this._cachedHasSearchFilter = true;
      } else {
        this._cachedHasSearchFilter = this._parent ? this._parent.hasSearchFilter : false;
      }
    }
    return this._cachedHasSearchFilter;
  }
  get searchFilter() {
    if (!this._cachedSearchFilter) {
      if (this._value.hasSearchFilter) {
        this._cachedSearchFilter = new dcei_engine_effect_proto.SearchFilter.WithParent(this._value.searchFilter, this._parent && this._parent.hasSearchFilter ? this._parent.searchFilter : null);
      } else {
        this._cachedSearchFilter = this._parent ? new dcei_engine_effect_proto.SearchFilter.WithParent(dcei_engine_effect_proto.SearchFilter.default, this._parent.searchFilter) : dcei_engine_effect_proto.SearchFilter.WithParent.default;
      }
    }
    return this._cachedSearchFilter;
  }
  get selfTargetValidators() {
    return this._value.targetValidators;
  }
  get inherentTargetValidators() {
    if (!this._inherentTargetValidators) {
      this._inherentTargetValidators = this._parent ? this._parent.targetValidators : [];
    }
    return this._inherentTargetValidators;
  }
  get targetValidators() {
    if (!this._allTargetValidators) {
      this._allTargetValidators = this._parent ? this._parent.targetValidators.concat(this.selfTargetValidators) : this.selfTargetValidators;
    }
    return this._allTargetValidators;
  }
  update(current, parent) {
    const result = new Validator_UnitWithinRange_WithParent(current, parent);
    if (this._cachedUnitCountRange && this._value.hasUnitCountRange && current.hasUnitCountRange) {
      if (this._value.unitCountRange === current.unitCountRange && this._parent === parent) {
        result._cachedUnitCountRange = this._cachedUnitCountRange;
      } else {
        result._cachedUnitCountRange = this._cachedUnitCountRange.update(current.unitCountRange, parent && parent.hasUnitCountRange ? parent.unitCountRange : null);
      }
    }
    if (this._cachedDeprecatedFilter && this._value.hasDeprecatedFilter && current.hasDeprecatedFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedDeprecatedFilter = this._cachedDeprecatedFilter;
      } else {
        result._cachedDeprecatedFilter = this._cachedDeprecatedFilter.update(current.filter, parent && parent.hasDeprecatedFilter ? parent.filter : null);
      }
    }
    if (this._cachedSearchFilter && this._value.hasSearchFilter && current.hasSearchFilter) {
      if (this._value.searchFilter === current.searchFilter && this._parent === parent) {
        result._cachedSearchFilter = this._cachedSearchFilter;
      } else {
        result._cachedSearchFilter = this._cachedSearchFilter.update(current.searchFilter, parent && parent.hasSearchFilter ? parent.searchFilter : null);
      }
    }
    return result;
  }
}
Validator_UnitWithinRange_WithParent.default = new Validator_UnitWithinRange_WithParent(Validator_UnitWithinRange.default, null);
Validator_UnitWithinRange.WithParent = Validator_UnitWithinRange_WithParent;
class Validator_UnitWithinRange_Descriptor {
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "Range",
        number: 1,
        protoType: 1,
        protoName: "range",
        type: JsonToDouble,
        options: {
          comments: "The radius of the circle to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get unitCountRange() {
    if (!this._unitCountRange) {
      this._unitCountRange = {
        name: "unitCountRange",
        Name: "UnitCountRange",
        number: 2,
        protoType: 11,
        protoName: "unit_count_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeInt,
        options: {
          comments: "returns true if the number of units found is between this min and max.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitCountRange;
  }
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "DeprecatedFilter",
        number: 1003,
        protoType: 11,
        protoName: "deprecated_filter",
        type: dcei_engine_effect_proto.OldSearchFilter,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get distanceCheckMode() {
    if (!this._distanceCheckMode) {
      this._distanceCheckMode = {
        name: "distanceCheckMode",
        Name: "DistanceCheckMode",
        number: 3,
        protoType: 14,
        protoName: "distance_check_mode",
        type: dcei_engine_effect_proto.DistanceCheckModes,
        options: {
          comments: "Determines whether to consider unit radius or center point when finding targets.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceCheckMode;
  }
  get distanceExtendMode() {
    if (!this._distanceExtendMode) {
      this._distanceExtendMode = {
        name: "distanceExtendMode",
        Name: "DistanceExtendMode",
        number: 4,
        protoType: 14,
        protoName: "distance_extend_mode",
        type: dcei_engine_effect_proto.DistanceExtendModes,
        options: {
          comments: "Determines whether to extend the search radius by the source unit\'s radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceExtendMode;
  }
  get searchFilter() {
    if (!this._searchFilter) {
      this._searchFilter = {
        name: "searchFilter",
        Name: "SearchFilter",
        number: 5,
        protoType: 11,
        protoName: "search_filter",
        type: dcei_engine_effect_proto.SearchFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._searchFilter;
  }
  get targetValidators() {
    if (!this._targetValidators) {
      this._targetValidators = {
        name: "targetValidators",
        Name: "TargetValidators",
        number: 6,
        protoType: 9,
        protoName: "target_validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Target units must pass these validators to be considered valid targets.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetValidators;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.range,
        this.unitCountRange,
        this.filter,
        this.distanceCheckMode,
        this.distanceExtendMode,
        this.searchFilter,
        this.targetValidators,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRange",
        Name: "DummyOneofForRange",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitCountRange",
        Name: "DummyOneofForUnitCountRange",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedFilter",
        Name: "DummyOneofForDeprecatedFilter",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceCheckMode",
        Name: "DummyOneofForDistanceCheckMode",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceExtendMode",
        Name: "DummyOneofForDistanceExtendMode",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSearchFilter",
        Name: "DummyOneofForSearchFilter",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitWithinRange.descriptor = new Validator_UnitWithinRange_Descriptor();
class Validator_NearbyUnitHealth {
  get descriptor() {
    return Validator_NearbyUnitHealth.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRange = false;
    this._range = null;
    this._hasUnitCountRange = false;
    this._unitCountRange = null;
    this._hasValueType = false;
    this._valueType = null;
    this._hasHealthValueRange = false;
    this._healthValueRange = null;
    this._hasCheckHealthUnitRange = false;
    this._checkHealthUnitRange = null;
    this._hasDeprecatedFilter = false;
    this._filter = null;
    this._hasDistanceCheckMode = false;
    this._distanceCheckMode = null;
    this._hasDistanceExtendMode = false;
    this._distanceExtendMode = null;
    this._hasSearchFilter = false;
    this._searchFilter = null;
  }
  isEmpty() {
    if (this._hasRange) return false;
    if (this._hasUnitCountRange && !this._unitCountRange.isEmpty()) return false;
    if (this._hasValueType) return false;
    if (this._hasHealthValueRange && !this._healthValueRange.isEmpty()) return false;
    if (this._hasCheckHealthUnitRange && !this._checkHealthUnitRange.isEmpty()) return false;
    if (this._hasDeprecatedFilter && !this._filter.isEmpty()) return false;
    if (this._hasDistanceCheckMode) return false;
    if (this._hasDistanceExtendMode) return false;
    if (this._hasSearchFilter && !this._searchFilter.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_NearbyUnitHealth) {
      return value;
    }
    return Validator_NearbyUnitHealth.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_NearbyUnitHealth();
    if (json.range != null) {
      result._hasRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.unitCountRange != null) {
      result._hasUnitCountRange = true;
      result._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromJson(json.unitCountRange);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = Validator_ValidatorValueType.fromJson(json.valueType);
    }
    if (json.healthValueRange != null) {
      result._hasHealthValueRange = true;
      result._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.fromJson(json.healthValueRange);
    }
    if (json.checkHealthUnitRange != null) {
      result._hasCheckHealthUnitRange = true;
      result._checkHealthUnitRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromJson(json.checkHealthUnitRange);
    }
    if (json.filter != null) {
      result._hasDeprecatedFilter = true;
      result._filter = dcei_engine_effect_proto.OldSearchFilter.fromJson(json.filter);
    }
    if (json.distanceCheckMode != null) {
      result._hasDistanceCheckMode = true;
      result._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromJson(json.distanceCheckMode);
    }
    if (json.distanceExtendMode != null) {
      result._hasDistanceExtendMode = true;
      result._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromJson(json.distanceExtendMode);
    }
    if (json.searchFilter != null) {
      result._hasSearchFilter = true;
      result._searchFilter = dcei_engine_effect_proto.SearchFilter.fromJson(json.searchFilter);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasUnitCountRange && !this._unitCountRange.isEmpty()) {
      result.unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.toJson(this._unitCountRange);
    }
    if (this._hasValueType) {
      result.valueType = Validator_ValidatorValueType.toJson(this._valueType);
    }
    if (this._hasHealthValueRange && !this._healthValueRange.isEmpty()) {
      result.healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.toJson(this._healthValueRange);
    }
    if (this._hasCheckHealthUnitRange && !this._checkHealthUnitRange.isEmpty()) {
      result.checkHealthUnitRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.toJson(this._checkHealthUnitRange);
    }
    if (this._hasDeprecatedFilter && !this._filter.isEmpty()) {
      result.filter = dcei_engine_effect_proto.OldSearchFilter.toJson(this._filter);
    }
    if (this._hasDistanceCheckMode) {
      result.distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.toJson(this._distanceCheckMode);
    }
    if (this._hasDistanceExtendMode) {
      result.distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.toJson(this._distanceExtendMode);
    }
    if (this._hasSearchFilter && !this._searchFilter.isEmpty()) {
      result.searchFilter = dcei_engine_effect_proto.SearchFilter.toJson(this._searchFilter);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasRange ? this._range : JsonToDouble.default;
  }
  get hasRange() {
    return this._hasRange;
  }
  setRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeInt}
   */
  get unitCountRange() {
    return this._hasUnitCountRange ? this._unitCountRange : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default;
  }
  get hasUnitCountRange() {
    return this._hasUnitCountRange;
  }
  setUnitCountRange(path, value) {
    return {type: 'SET', path: path.concat(['unitCountRange']), value: value.toJson()};
  }
  deleteUnitCountRange(path) {
    return {type: 'DELETE', path: path.concat(['unitCountRange'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : Validator_ValidatorValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeDouble}
   */
  get healthValueRange() {
    return this._hasHealthValueRange ? this._healthValueRange : dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default;
  }
  get hasHealthValueRange() {
    return this._hasHealthValueRange;
  }
  setHealthValueRange(path, value) {
    return {type: 'SET', path: path.concat(['healthValueRange']), value: value.toJson()};
  }
  deleteHealthValueRange(path) {
    return {type: 'DELETE', path: path.concat(['healthValueRange'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeInt}
   */
  get checkHealthUnitRange() {
    return this._hasCheckHealthUnitRange ? this._checkHealthUnitRange : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default;
  }
  get hasCheckHealthUnitRange() {
    return this._hasCheckHealthUnitRange;
  }
  setCheckHealthUnitRange(path, value) {
    return {type: 'SET', path: path.concat(['checkHealthUnitRange']), value: value.toJson()};
  }
  deleteCheckHealthUnitRange(path) {
    return {type: 'DELETE', path: path.concat(['checkHealthUnitRange'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.OldSearchFilter}
   */
  get filter() {
    return this._hasDeprecatedFilter ? this._filter : dcei_engine_effect_proto.OldSearchFilter.default;
  }
  get hasDeprecatedFilter() {
    return this._hasDeprecatedFilter;
  }
  setDeprecatedFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteDeprecatedFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {number}
   */
  get distanceCheckMode() {
    return this._hasDistanceCheckMode ? this._distanceCheckMode : dcei_engine_effect_proto.DistanceCheckModes.default;
  }
  get hasDistanceCheckMode() {
    return this._hasDistanceCheckMode;
  }
  setDistanceCheckMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceCheckMode']), value};
  }
  deleteDistanceCheckMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceCheckMode'])};
  }
  /**
   * @returns {number}
   */
  get distanceExtendMode() {
    return this._hasDistanceExtendMode ? this._distanceExtendMode : dcei_engine_effect_proto.DistanceExtendModes.default;
  }
  get hasDistanceExtendMode() {
    return this._hasDistanceExtendMode;
  }
  setDistanceExtendMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceExtendMode']), value};
  }
  deleteDistanceExtendMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceExtendMode'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.SearchFilter}
   */
  get searchFilter() {
    return this._hasSearchFilter ? this._searchFilter : dcei_engine_effect_proto.SearchFilter.default;
  }
  get hasSearchFilter() {
    return this._hasSearchFilter;
  }
  setSearchFilter(path, value) {
    return {type: 'SET', path: path.concat(['searchFilter']), value: value.toJson()};
  }
  deleteSearchFilter(path) {
    return {type: 'DELETE', path: path.concat(['searchFilter'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRange) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitCountRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasUnitCountRange = true;
              copy._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitCountRange) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasUnitCountRange = false;
              copy._unitCountRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitCountRange) {
            const copy = new Validator_NearbyUnitHealth(this);
            copy._hasUnitCountRange = true;
            copy._unitCountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitCountRange.apply(type, path.slice(1), value);
          if (newValue === this._unitCountRange) {
            return this;
          }
          const copy = new Validator_NearbyUnitHealth(this);
          copy._unitCountRange = copy._unitCountRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasValueType = true;
              copy._valueType = Validator_ValidatorValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "healthValueRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasHealthValueRange = true;
              copy._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealthValueRange) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasHealthValueRange = false;
              copy._healthValueRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealthValueRange) {
            const copy = new Validator_NearbyUnitHealth(this);
            copy._hasHealthValueRange = true;
            copy._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healthValueRange.apply(type, path.slice(1), value);
          if (newValue === this._healthValueRange) {
            return this;
          }
          const copy = new Validator_NearbyUnitHealth(this);
          copy._healthValueRange = copy._healthValueRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "checkHealthUnitRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasCheckHealthUnitRange = true;
              copy._checkHealthUnitRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCheckHealthUnitRange) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasCheckHealthUnitRange = false;
              copy._checkHealthUnitRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCheckHealthUnitRange) {
            const copy = new Validator_NearbyUnitHealth(this);
            copy._hasCheckHealthUnitRange = true;
            copy._checkHealthUnitRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._checkHealthUnitRange.apply(type, path.slice(1), value);
          if (newValue === this._checkHealthUnitRange) {
            return this;
          }
          const copy = new Validator_NearbyUnitHealth(this);
          copy._checkHealthUnitRange = copy._checkHealthUnitRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDeprecatedFilter = true;
              copy._filter = dcei_engine_effect_proto.OldSearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedFilter) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDeprecatedFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeprecatedFilter) {
            const copy = new Validator_NearbyUnitHealth(this);
            copy._hasDeprecatedFilter = true;
            copy._filter = dcei_engine_effect_proto.OldSearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new Validator_NearbyUnitHealth(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "distanceCheckMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDistanceCheckMode = true;
              copy._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceCheckMode) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDistanceCheckMode = false;
              copy._distanceCheckMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceExtendMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDistanceExtendMode = true;
              copy._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceExtendMode) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasDistanceExtendMode = false;
              copy._distanceExtendMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "searchFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasSearchFilter = true;
              copy._searchFilter = dcei_engine_effect_proto.SearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSearchFilter) {
                return this;
              }
              const copy = new Validator_NearbyUnitHealth(this);
              copy._hasSearchFilter = false;
              copy._searchFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSearchFilter) {
            const copy = new Validator_NearbyUnitHealth(this);
            copy._hasSearchFilter = true;
            copy._searchFilter = dcei_engine_effect_proto.SearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._searchFilter.apply(type, path.slice(1), value);
          if (newValue === this._searchFilter) {
            return this;
          }
          const copy = new Validator_NearbyUnitHealth(this);
          copy._searchFilter = copy._searchFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_NearbyUnitHealth} other
   * @returns {Validator_NearbyUnitHealth}
   */
  merge(other) {
    const copy = new Validator_NearbyUnitHealth(this);
    if (other._hasRange) {
      copy._hasRange = true;
      copy._range = other._range;
    }
    if (other._hasUnitCountRange) {
      if (copy._hasUnitCountRange) {
        copy._unitCountRange = copy.unitCountRange.merge(other.unitCountRange);
      } else {
        copy._unitCountRange = other._unitCountRange;
      }
      copy._hasUnitCountRange = true;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasHealthValueRange) {
      if (copy._hasHealthValueRange) {
        copy._healthValueRange = copy.healthValueRange.merge(other.healthValueRange);
      } else {
        copy._healthValueRange = other._healthValueRange;
      }
      copy._hasHealthValueRange = true;
    }
    if (other._hasCheckHealthUnitRange) {
      if (copy._hasCheckHealthUnitRange) {
        copy._checkHealthUnitRange = copy.checkHealthUnitRange.merge(other.checkHealthUnitRange);
      } else {
        copy._checkHealthUnitRange = other._checkHealthUnitRange;
      }
      copy._hasCheckHealthUnitRange = true;
    }
    if (other._hasDeprecatedFilter) {
      if (copy._hasDeprecatedFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasDeprecatedFilter = true;
    }
    if (other._hasDistanceCheckMode) {
      copy._hasDistanceCheckMode = true;
      copy._distanceCheckMode = other._distanceCheckMode;
    }
    if (other._hasDistanceExtendMode) {
      copy._hasDistanceExtendMode = true;
      copy._distanceExtendMode = other._distanceExtendMode;
    }
    if (other._hasSearchFilter) {
      if (copy._hasSearchFilter) {
        copy._searchFilter = copy.searchFilter.merge(other.searchFilter);
      } else {
        copy._searchFilter = other._searchFilter;
      }
      copy._hasSearchFilter = true;
    }
    return copy;
  }
}
Validator_NearbyUnitHealth.default = new Validator_NearbyUnitHealth();
class Validator_NearbyUnitHealth_Builder {
  constructor(value) {
    this._value = new Validator_NearbyUnitHealth(value);
  }
  build() {
    return new Validator_NearbyUnitHealth(this._value);
  }
  setRange(value) {
    this._value._hasRange = true;
    this._value._range = value;
    return this;
  }
  deleteRange() {
    this._value._hasRange = false;
    this._value._range = null;
    return this;
  }
  setUnitCountRange(value) {
    this._value._hasUnitCountRange = true;
    this._value._unitCountRange = value;
    return this;
  }
  deleteUnitCountRange() {
    this._value._hasUnitCountRange = false;
    this._value._unitCountRange = null;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setHealthValueRange(value) {
    this._value._hasHealthValueRange = true;
    this._value._healthValueRange = value;
    return this;
  }
  deleteHealthValueRange() {
    this._value._hasHealthValueRange = false;
    this._value._healthValueRange = null;
    return this;
  }
  setCheckHealthUnitRange(value) {
    this._value._hasCheckHealthUnitRange = true;
    this._value._checkHealthUnitRange = value;
    return this;
  }
  deleteCheckHealthUnitRange() {
    this._value._hasCheckHealthUnitRange = false;
    this._value._checkHealthUnitRange = null;
    return this;
  }
  setDeprecatedFilter(value) {
    this._value._hasDeprecatedFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteDeprecatedFilter() {
    this._value._hasDeprecatedFilter = false;
    this._value._filter = null;
    return this;
  }
  setDistanceCheckMode(value) {
    this._value._hasDistanceCheckMode = true;
    this._value._distanceCheckMode = value;
    return this;
  }
  deleteDistanceCheckMode() {
    this._value._hasDistanceCheckMode = false;
    this._value._distanceCheckMode = null;
    return this;
  }
  setDistanceExtendMode(value) {
    this._value._hasDistanceExtendMode = true;
    this._value._distanceExtendMode = value;
    return this;
  }
  deleteDistanceExtendMode() {
    this._value._hasDistanceExtendMode = false;
    this._value._distanceExtendMode = null;
    return this;
  }
  setSearchFilter(value) {
    this._value._hasSearchFilter = true;
    this._value._searchFilter = value;
    return this;
  }
  deleteSearchFilter() {
    this._value._hasSearchFilter = false;
    this._value._searchFilter = null;
    return this;
  }
}
Validator_NearbyUnitHealth.Builder = Validator_NearbyUnitHealth_Builder;
class Validator_NearbyUnitHealth_WithParent {
  /**
   * @param {Validator_NearbyUnitHealth} value
   * @param {Validator_NearbyUnitHealth_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_NearbyUnitHealth.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRange() {
    if (this._cachedHasRange === undefined) {
      if (this._value.hasRange) {
        this._cachedHasRange = true;
      } else {
        this._cachedHasRange = this._parent ? this._parent.hasRange : false;
      }
    }
    return this._cachedHasRange;
  }
  get range() {
    if (this._cachedRange === undefined) {
      if (this._value.hasRange) {
        this._cachedRange = this._value.range;
      } else {
        this._cachedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedRange;
  }
  get hasUnitCountRange() {
    if (this._cachedHasUnitCountRange === undefined) {
      if (this._value.hasUnitCountRange) {
        this._cachedHasUnitCountRange = true;
      } else {
        this._cachedHasUnitCountRange = this._parent ? this._parent.hasUnitCountRange : false;
      }
    }
    return this._cachedHasUnitCountRange;
  }
  get unitCountRange() {
    if (!this._cachedUnitCountRange) {
      if (this._value.hasUnitCountRange) {
        this._cachedUnitCountRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(this._value.unitCountRange, this._parent && this._parent.hasUnitCountRange ? this._parent.unitCountRange : null);
      } else {
        this._cachedUnitCountRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default, this._parent.unitCountRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent.default;
      }
    }
    return this._cachedUnitCountRange;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasHealthValueRange() {
    if (this._cachedHasHealthValueRange === undefined) {
      if (this._value.hasHealthValueRange) {
        this._cachedHasHealthValueRange = true;
      } else {
        this._cachedHasHealthValueRange = this._parent ? this._parent.hasHealthValueRange : false;
      }
    }
    return this._cachedHasHealthValueRange;
  }
  get healthValueRange() {
    if (!this._cachedHealthValueRange) {
      if (this._value.hasHealthValueRange) {
        this._cachedHealthValueRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent(this._value.healthValueRange, this._parent && this._parent.hasHealthValueRange ? this._parent.healthValueRange : null);
      } else {
        this._cachedHealthValueRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default, this._parent.healthValueRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent.default;
      }
    }
    return this._cachedHealthValueRange;
  }
  get hasCheckHealthUnitRange() {
    if (this._cachedHasCheckHealthUnitRange === undefined) {
      if (this._value.hasCheckHealthUnitRange) {
        this._cachedHasCheckHealthUnitRange = true;
      } else {
        this._cachedHasCheckHealthUnitRange = this._parent ? this._parent.hasCheckHealthUnitRange : false;
      }
    }
    return this._cachedHasCheckHealthUnitRange;
  }
  get checkHealthUnitRange() {
    if (!this._cachedCheckHealthUnitRange) {
      if (this._value.hasCheckHealthUnitRange) {
        this._cachedCheckHealthUnitRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(this._value.checkHealthUnitRange, this._parent && this._parent.hasCheckHealthUnitRange ? this._parent.checkHealthUnitRange : null);
      } else {
        this._cachedCheckHealthUnitRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default, this._parent.checkHealthUnitRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent.default;
      }
    }
    return this._cachedCheckHealthUnitRange;
  }
  get hasDeprecatedFilter() {
    if (this._cachedHasDeprecatedFilter === undefined) {
      if (this._value.hasDeprecatedFilter) {
        this._cachedHasDeprecatedFilter = true;
      } else {
        this._cachedHasDeprecatedFilter = this._parent ? this._parent.hasDeprecatedFilter : false;
      }
    }
    return this._cachedHasDeprecatedFilter;
  }
  get filter() {
    if (!this._cachedDeprecatedFilter) {
      if (this._value.hasDeprecatedFilter) {
        this._cachedDeprecatedFilter = new dcei_engine_effect_proto.OldSearchFilter.WithParent(this._value.filter, this._parent && this._parent.hasDeprecatedFilter ? this._parent.filter : null);
      } else {
        this._cachedDeprecatedFilter = this._parent ? new dcei_engine_effect_proto.OldSearchFilter.WithParent(dcei_engine_effect_proto.OldSearchFilter.default, this._parent.filter) : dcei_engine_effect_proto.OldSearchFilter.WithParent.default;
      }
    }
    return this._cachedDeprecatedFilter;
  }
  get hasDistanceCheckMode() {
    if (this._cachedHasDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedHasDistanceCheckMode = true;
      } else {
        this._cachedHasDistanceCheckMode = this._parent ? this._parent.hasDistanceCheckMode : false;
      }
    }
    return this._cachedHasDistanceCheckMode;
  }
  get distanceCheckMode() {
    if (this._cachedDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedDistanceCheckMode = this._value.distanceCheckMode;
      } else {
        this._cachedDistanceCheckMode = this._parent ? this._parent.distanceCheckMode : this._value.distanceCheckMode;
      }
    }
    return this._cachedDistanceCheckMode;
  }
  get hasDistanceExtendMode() {
    if (this._cachedHasDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedHasDistanceExtendMode = true;
      } else {
        this._cachedHasDistanceExtendMode = this._parent ? this._parent.hasDistanceExtendMode : false;
      }
    }
    return this._cachedHasDistanceExtendMode;
  }
  get distanceExtendMode() {
    if (this._cachedDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedDistanceExtendMode = this._value.distanceExtendMode;
      } else {
        this._cachedDistanceExtendMode = this._parent ? this._parent.distanceExtendMode : this._value.distanceExtendMode;
      }
    }
    return this._cachedDistanceExtendMode;
  }
  get hasSearchFilter() {
    if (this._cachedHasSearchFilter === undefined) {
      if (this._value.hasSearchFilter) {
        this._cachedHasSearchFilter = true;
      } else {
        this._cachedHasSearchFilter = this._parent ? this._parent.hasSearchFilter : false;
      }
    }
    return this._cachedHasSearchFilter;
  }
  get searchFilter() {
    if (!this._cachedSearchFilter) {
      if (this._value.hasSearchFilter) {
        this._cachedSearchFilter = new dcei_engine_effect_proto.SearchFilter.WithParent(this._value.searchFilter, this._parent && this._parent.hasSearchFilter ? this._parent.searchFilter : null);
      } else {
        this._cachedSearchFilter = this._parent ? new dcei_engine_effect_proto.SearchFilter.WithParent(dcei_engine_effect_proto.SearchFilter.default, this._parent.searchFilter) : dcei_engine_effect_proto.SearchFilter.WithParent.default;
      }
    }
    return this._cachedSearchFilter;
  }
  update(current, parent) {
    const result = new Validator_NearbyUnitHealth_WithParent(current, parent);
    if (this._cachedUnitCountRange && this._value.hasUnitCountRange && current.hasUnitCountRange) {
      if (this._value.unitCountRange === current.unitCountRange && this._parent === parent) {
        result._cachedUnitCountRange = this._cachedUnitCountRange;
      } else {
        result._cachedUnitCountRange = this._cachedUnitCountRange.update(current.unitCountRange, parent && parent.hasUnitCountRange ? parent.unitCountRange : null);
      }
    }
    if (this._cachedHealthValueRange && this._value.hasHealthValueRange && current.hasHealthValueRange) {
      if (this._value.healthValueRange === current.healthValueRange && this._parent === parent) {
        result._cachedHealthValueRange = this._cachedHealthValueRange;
      } else {
        result._cachedHealthValueRange = this._cachedHealthValueRange.update(current.healthValueRange, parent && parent.hasHealthValueRange ? parent.healthValueRange : null);
      }
    }
    if (this._cachedCheckHealthUnitRange && this._value.hasCheckHealthUnitRange && current.hasCheckHealthUnitRange) {
      if (this._value.checkHealthUnitRange === current.checkHealthUnitRange && this._parent === parent) {
        result._cachedCheckHealthUnitRange = this._cachedCheckHealthUnitRange;
      } else {
        result._cachedCheckHealthUnitRange = this._cachedCheckHealthUnitRange.update(current.checkHealthUnitRange, parent && parent.hasCheckHealthUnitRange ? parent.checkHealthUnitRange : null);
      }
    }
    if (this._cachedDeprecatedFilter && this._value.hasDeprecatedFilter && current.hasDeprecatedFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedDeprecatedFilter = this._cachedDeprecatedFilter;
      } else {
        result._cachedDeprecatedFilter = this._cachedDeprecatedFilter.update(current.filter, parent && parent.hasDeprecatedFilter ? parent.filter : null);
      }
    }
    if (this._cachedSearchFilter && this._value.hasSearchFilter && current.hasSearchFilter) {
      if (this._value.searchFilter === current.searchFilter && this._parent === parent) {
        result._cachedSearchFilter = this._cachedSearchFilter;
      } else {
        result._cachedSearchFilter = this._cachedSearchFilter.update(current.searchFilter, parent && parent.hasSearchFilter ? parent.searchFilter : null);
      }
    }
    return result;
  }
}
Validator_NearbyUnitHealth_WithParent.default = new Validator_NearbyUnitHealth_WithParent(Validator_NearbyUnitHealth.default, null);
Validator_NearbyUnitHealth.WithParent = Validator_NearbyUnitHealth_WithParent;
class Validator_NearbyUnitHealth_Descriptor {
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "Range",
        number: 1,
        protoType: 1,
        protoName: "range",
        type: JsonToDouble,
        options: {
          comments: "The radius of the circle to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get unitCountRange() {
    if (!this._unitCountRange) {
      this._unitCountRange = {
        name: "unitCountRange",
        Name: "UnitCountRange",
        number: 2,
        protoType: 11,
        protoName: "unit_count_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeInt,
        options: {
          comments: "Returns true if the number of units found is between this min and max.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitCountRange;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 3,
        protoType: 14,
        protoName: "value_type",
        type: Validator_ValidatorValueType,
        options: {
          comments: "Whether the validator will check units\' health as an **Absolute** or **Percentage** (between 0 and 1).",
          default: "ABSOLUTE",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get healthValueRange() {
    if (!this._healthValueRange) {
      this._healthValueRange = {
        name: "healthValueRange",
        Name: "HealthValueRange",
        number: 4,
        protoType: 11,
        protoName: "health_value_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeDouble,
        options: {
          comments: "Returns true if enough units are found with health within this min and max.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthValueRange;
  }
  get checkHealthUnitRange() {
    if (!this._checkHealthUnitRange) {
      this._checkHealthUnitRange = {
        name: "checkHealthUnitRange",
        Name: "CheckHealthUnitRange",
        number: 5,
        protoType: 11,
        protoName: "check_health_unit_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeInt,
        options: {
          comments: "Determines how many units must be found with the health value specified in **Health Value Range**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._checkHealthUnitRange;
  }
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "DeprecatedFilter",
        number: 1006,
        protoType: 11,
        protoName: "deprecated_filter",
        type: dcei_engine_effect_proto.OldSearchFilter,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get distanceCheckMode() {
    if (!this._distanceCheckMode) {
      this._distanceCheckMode = {
        name: "distanceCheckMode",
        Name: "DistanceCheckMode",
        number: 6,
        protoType: 14,
        protoName: "distance_check_mode",
        type: dcei_engine_effect_proto.DistanceCheckModes,
        options: {
          comments: "Determines whether to consider unit radius or center point when finding targets.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceCheckMode;
  }
  get distanceExtendMode() {
    if (!this._distanceExtendMode) {
      this._distanceExtendMode = {
        name: "distanceExtendMode",
        Name: "DistanceExtendMode",
        number: 7,
        protoType: 14,
        protoName: "distance_extend_mode",
        type: dcei_engine_effect_proto.DistanceExtendModes,
        options: {
          comments: "Determines whether to extend the search radius by the source unit\'s radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceExtendMode;
  }
  get searchFilter() {
    if (!this._searchFilter) {
      this._searchFilter = {
        name: "searchFilter",
        Name: "SearchFilter",
        number: 8,
        protoType: 11,
        protoName: "search_filter",
        type: dcei_engine_effect_proto.SearchFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._searchFilter;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.range,
        this.unitCountRange,
        this.valueType,
        this.healthValueRange,
        this.checkHealthUnitRange,
        this.filter,
        this.distanceCheckMode,
        this.distanceExtendMode,
        this.searchFilter,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRange",
        Name: "DummyOneofForRange",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitCountRange",
        Name: "DummyOneofForUnitCountRange",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealthValueRange",
        Name: "DummyOneofForHealthValueRange",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCheckHealthUnitRange",
        Name: "DummyOneofForCheckHealthUnitRange",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedFilter",
        Name: "DummyOneofForDeprecatedFilter",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceCheckMode",
        Name: "DummyOneofForDistanceCheckMode",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceExtendMode",
        Name: "DummyOneofForDistanceExtendMode",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSearchFilter",
        Name: "DummyOneofForSearchFilter",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_NearbyUnitHealth.descriptor = new Validator_NearbyUnitHealth_Descriptor();
class Validator_HealthValue {
  get descriptor() {
    return Validator_HealthValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasHealthValueRange = false;
    this._healthValueRange = null;
    this._hasValueType = false;
    this._valueType = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasHealthValueRange && !this._healthValueRange.isEmpty()) return false;
    if (this._hasValueType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_HealthValue) {
      return value;
    }
    return Validator_HealthValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_HealthValue();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    if (json.healthValueRange != null) {
      result._hasHealthValueRange = true;
      result._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.fromJson(json.healthValueRange);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = Validator_ValidatorValueType.fromJson(json.valueType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    if (this._hasHealthValueRange && !this._healthValueRange.isEmpty()) {
      result.healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.toJson(this._healthValueRange);
    }
    if (this._hasValueType) {
      result.valueType = Validator_ValidatorValueType.toJson(this._valueType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeDouble}
   */
  get healthValueRange() {
    return this._hasHealthValueRange ? this._healthValueRange : dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default;
  }
  get hasHealthValueRange() {
    return this._hasHealthValueRange;
  }
  setHealthValueRange(path, value) {
    return {type: 'SET', path: path.concat(['healthValueRange']), value: value.toJson()};
  }
  deleteHealthValueRange(path) {
    return {type: 'DELETE', path: path.concat(['healthValueRange'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : Validator_ValidatorValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_HealthValue(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_HealthValue(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "healthValueRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_HealthValue(this);
              copy._hasHealthValueRange = true;
              copy._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealthValueRange) {
                return this;
              }
              const copy = new Validator_HealthValue(this);
              copy._hasHealthValueRange = false;
              copy._healthValueRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealthValueRange) {
            const copy = new Validator_HealthValue(this);
            copy._hasHealthValueRange = true;
            copy._healthValueRange = dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healthValueRange.apply(type, path.slice(1), value);
          if (newValue === this._healthValueRange) {
            return this;
          }
          const copy = new Validator_HealthValue(this);
          copy._healthValueRange = copy._healthValueRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_HealthValue(this);
              copy._hasValueType = true;
              copy._valueType = Validator_ValidatorValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new Validator_HealthValue(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_HealthValue} other
   * @returns {Validator_HealthValue}
   */
  merge(other) {
    const copy = new Validator_HealthValue(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasHealthValueRange) {
      if (copy._hasHealthValueRange) {
        copy._healthValueRange = copy.healthValueRange.merge(other.healthValueRange);
      } else {
        copy._healthValueRange = other._healthValueRange;
      }
      copy._hasHealthValueRange = true;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    return copy;
  }
}
Validator_HealthValue.default = new Validator_HealthValue();
class Validator_HealthValue_Builder {
  constructor(value) {
    this._value = new Validator_HealthValue(value);
  }
  build() {
    return new Validator_HealthValue(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setHealthValueRange(value) {
    this._value._hasHealthValueRange = true;
    this._value._healthValueRange = value;
    return this;
  }
  deleteHealthValueRange() {
    this._value._hasHealthValueRange = false;
    this._value._healthValueRange = null;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
}
Validator_HealthValue.Builder = Validator_HealthValue_Builder;
class Validator_HealthValue_WithParent {
  /**
   * @param {Validator_HealthValue} value
   * @param {Validator_HealthValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_HealthValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasHealthValueRange() {
    if (this._cachedHasHealthValueRange === undefined) {
      if (this._value.hasHealthValueRange) {
        this._cachedHasHealthValueRange = true;
      } else {
        this._cachedHasHealthValueRange = this._parent ? this._parent.hasHealthValueRange : false;
      }
    }
    return this._cachedHasHealthValueRange;
  }
  get healthValueRange() {
    if (!this._cachedHealthValueRange) {
      if (this._value.hasHealthValueRange) {
        this._cachedHealthValueRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent(this._value.healthValueRange, this._parent && this._parent.hasHealthValueRange ? this._parent.healthValueRange : null);
      } else {
        this._cachedHealthValueRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.default, this._parent.healthValueRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeDouble.WithParent.default;
      }
    }
    return this._cachedHealthValueRange;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  update(current, parent) {
    const result = new Validator_HealthValue_WithParent(current, parent);
    if (this._cachedHealthValueRange && this._value.hasHealthValueRange && current.hasHealthValueRange) {
      if (this._value.healthValueRange === current.healthValueRange && this._parent === parent) {
        result._cachedHealthValueRange = this._cachedHealthValueRange;
      } else {
        result._cachedHealthValueRange = this._cachedHealthValueRange.update(current.healthValueRange, parent && parent.hasHealthValueRange ? parent.healthValueRange : null);
      }
    }
    return result;
  }
}
Validator_HealthValue_WithParent.default = new Validator_HealthValue_WithParent(Validator_HealthValue.default, null);
Validator_HealthValue.WithParent = Validator_HealthValue_WithParent;
class Validator_HealthValue_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit will be considered by the validator. Using NONE defaults to TARGET_UNIT.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get healthValueRange() {
    if (!this._healthValueRange) {
      this._healthValueRange = {
        name: "healthValueRange",
        Name: "HealthValueRange",
        number: 2,
        protoType: 11,
        protoName: "health_value_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeDouble,
        options: {
          comments: "Returns true if the checked unit\'s health is within this min and max.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthValueRange;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 3,
        protoType: 14,
        protoName: "value_type",
        type: Validator_ValidatorValueType,
        options: {
          comments: "Whether the validator will check health as an **Absolute** or **Percentage** (between 0 and 1).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.healthValueRange,
        this.valueType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealthValueRange",
        Name: "DummyOneofForHealthValueRange",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_HealthValue.descriptor = new Validator_HealthValue_Descriptor();
class Validator_TroopAmount {
  get descriptor() {
    return Validator_TroopAmount.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAmountRange = false;
    this._amountRange = null;
    this._hasUnitTypeName = false;
    this._unitTypeName = null;
  }
  isEmpty() {
    if (this._hasAmountRange && !this._amountRange.isEmpty()) return false;
    if (this._hasUnitTypeName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_TroopAmount) {
      return value;
    }
    return Validator_TroopAmount.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_TroopAmount();
    if (json.amountRange != null) {
      result._hasAmountRange = true;
      result._amountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromJson(json.amountRange);
    }
    if (json.unitTypeName != null) {
      result._hasUnitTypeName = true;
      result._unitTypeName = JsonToString.fromJson(json.unitTypeName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAmountRange && !this._amountRange.isEmpty()) {
      result.amountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.toJson(this._amountRange);
    }
    if (this._hasUnitTypeName) {
      result.unitTypeName = JsonToString.toJson(this._unitTypeName);
    }
    return result;
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.RangeInt}
   */
  get amountRange() {
    return this._hasAmountRange ? this._amountRange : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default;
  }
  get hasAmountRange() {
    return this._hasAmountRange;
  }
  setAmountRange(path, value) {
    return {type: 'SET', path: path.concat(['amountRange']), value: value.toJson()};
  }
  deleteAmountRange(path) {
    return {type: 'DELETE', path: path.concat(['amountRange'])};
  }
  /**
   * @returns {string}
   */
  get unitTypeName() {
    return this._hasUnitTypeName ? this._unitTypeName : JsonToString.default;
  }
  get hasUnitTypeName() {
    return this._hasUnitTypeName;
  }
  setUnitTypeName(path, value) {
    return {type: 'SET', path: path.concat(['unitTypeName']), value};
  }
  deleteUnitTypeName(path) {
    return {type: 'DELETE', path: path.concat(['unitTypeName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "amountRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_TroopAmount(this);
              copy._hasAmountRange = true;
              copy._amountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountRange) {
                return this;
              }
              const copy = new Validator_TroopAmount(this);
              copy._hasAmountRange = false;
              copy._amountRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAmountRange) {
            const copy = new Validator_TroopAmount(this);
            copy._hasAmountRange = true;
            copy._amountRange = dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._amountRange.apply(type, path.slice(1), value);
          if (newValue === this._amountRange) {
            return this;
          }
          const copy = new Validator_TroopAmount(this);
          copy._amountRange = copy._amountRange.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitTypeName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_TroopAmount(this);
              copy._hasUnitTypeName = true;
              copy._unitTypeName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitTypeName) {
                return this;
              }
              const copy = new Validator_TroopAmount(this);
              copy._hasUnitTypeName = false;
              copy._unitTypeName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_TroopAmount} other
   * @returns {Validator_TroopAmount}
   */
  merge(other) {
    const copy = new Validator_TroopAmount(this);
    if (other._hasAmountRange) {
      if (copy._hasAmountRange) {
        copy._amountRange = copy.amountRange.merge(other.amountRange);
      } else {
        copy._amountRange = other._amountRange;
      }
      copy._hasAmountRange = true;
    }
    if (other._hasUnitTypeName) {
      copy._hasUnitTypeName = true;
      copy._unitTypeName = other._unitTypeName;
    }
    return copy;
  }
}
Validator_TroopAmount.default = new Validator_TroopAmount();
class Validator_TroopAmount_Builder {
  constructor(value) {
    this._value = new Validator_TroopAmount(value);
  }
  build() {
    return new Validator_TroopAmount(this._value);
  }
  setAmountRange(value) {
    this._value._hasAmountRange = true;
    this._value._amountRange = value;
    return this;
  }
  deleteAmountRange() {
    this._value._hasAmountRange = false;
    this._value._amountRange = null;
    return this;
  }
  setUnitTypeName(value) {
    this._value._hasUnitTypeName = true;
    this._value._unitTypeName = value;
    return this;
  }
  deleteUnitTypeName() {
    this._value._hasUnitTypeName = false;
    this._value._unitTypeName = null;
    return this;
  }
}
Validator_TroopAmount.Builder = Validator_TroopAmount_Builder;
class Validator_TroopAmount_WithParent {
  /**
   * @param {Validator_TroopAmount} value
   * @param {Validator_TroopAmount_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_TroopAmount.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAmountRange() {
    if (this._cachedHasAmountRange === undefined) {
      if (this._value.hasAmountRange) {
        this._cachedHasAmountRange = true;
      } else {
        this._cachedHasAmountRange = this._parent ? this._parent.hasAmountRange : false;
      }
    }
    return this._cachedHasAmountRange;
  }
  get amountRange() {
    if (!this._cachedAmountRange) {
      if (this._value.hasAmountRange) {
        this._cachedAmountRange = new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(this._value.amountRange, this._parent && this._parent.hasAmountRange ? this._parent.amountRange : null);
      } else {
        this._cachedAmountRange = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent(dcei_engine_expression_proto.ValidatorExpressions.RangeInt.default, this._parent.amountRange) : dcei_engine_expression_proto.ValidatorExpressions.RangeInt.WithParent.default;
      }
    }
    return this._cachedAmountRange;
  }
  get hasUnitTypeName() {
    if (this._cachedHasUnitTypeName === undefined) {
      if (this._value.hasUnitTypeName) {
        this._cachedHasUnitTypeName = true;
      } else {
        this._cachedHasUnitTypeName = this._parent ? this._parent.hasUnitTypeName : false;
      }
    }
    return this._cachedHasUnitTypeName;
  }
  get unitTypeName() {
    if (this._cachedUnitTypeName === undefined) {
      if (this._value.hasUnitTypeName) {
        this._cachedUnitTypeName = this._value.unitTypeName;
      } else {
        this._cachedUnitTypeName = this._parent ? this._parent.unitTypeName : this._value.unitTypeName;
      }
    }
    return this._cachedUnitTypeName;
  }
  update(current, parent) {
    const result = new Validator_TroopAmount_WithParent(current, parent);
    if (this._cachedAmountRange && this._value.hasAmountRange && current.hasAmountRange) {
      if (this._value.amountRange === current.amountRange && this._parent === parent) {
        result._cachedAmountRange = this._cachedAmountRange;
      } else {
        result._cachedAmountRange = this._cachedAmountRange.update(current.amountRange, parent && parent.hasAmountRange ? parent.amountRange : null);
      }
    }
    return result;
  }
}
Validator_TroopAmount_WithParent.default = new Validator_TroopAmount_WithParent(Validator_TroopAmount.default, null);
Validator_TroopAmount.WithParent = Validator_TroopAmount_WithParent;
class Validator_TroopAmount_Descriptor {
  get amountRange() {
    if (!this._amountRange) {
      this._amountRange = {
        name: "amountRange",
        Name: "AmountRange",
        number: 1,
        protoType: 11,
        protoName: "amount_range",
        type: dcei_engine_expression_proto.ValidatorExpressions.RangeInt,
        options: {
          comments: "Returns true of the unit has a specified number of child troop units.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountRange;
  }
  get unitTypeName() {
    if (!this._unitTypeName) {
      this._unitTypeName = {
        name: "unitTypeName",
        Name: "UnitTypeName",
        number: 2,
        protoType: 9,
        protoName: "unit_type_name",
        type: JsonToString,
        options: {
          comments: "Returns true if enough units are found with health within this min and max.",
          valueDropdown: "SupportedBaseUnitNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitTypeName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.amountRange,
        this.unitTypeName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAmountRange",
        Name: "DummyOneofForAmountRange",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitTypeName",
        Name: "DummyOneofForUnitTypeName",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_TroopAmount.descriptor = new Validator_TroopAmount_Descriptor();
class Validator_UnitFilter {
  get descriptor() {
    return Validator_UnitFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValidateUnitFilter = false;
    this._validateUnitFilter = null;
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasValidateUnitFilter) return false;
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitFilter) {
      return value;
    }
    return Validator_UnitFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitFilter();
    if (json.validateUnitFilter != null) {
      result._hasValidateUnitFilter = true;
      result._validateUnitFilter = dcei_engine_unit_proto.UnitComponent.UnitType.fromJson(json.validateUnitFilter);
    }
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValidateUnitFilter) {
      result.validateUnitFilter = dcei_engine_unit_proto.UnitComponent.UnitType.toJson(this._validateUnitFilter);
    }
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get validateUnitFilter() {
    return this._hasValidateUnitFilter ? this._validateUnitFilter : dcei_engine_unit_proto.UnitComponent.UnitType.default;
  }
  get hasValidateUnitFilter() {
    return this._hasValidateUnitFilter;
  }
  setValidateUnitFilter(path, value) {
    return {type: 'SET', path: path.concat(['validateUnitFilter']), value};
  }
  deleteValidateUnitFilter(path) {
    return {type: 'DELETE', path: path.concat(['validateUnitFilter'])};
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "validateUnitFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitFilter(this);
              copy._hasValidateUnitFilter = true;
              copy._validateUnitFilter = dcei_engine_unit_proto.UnitComponent.UnitType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValidateUnitFilter) {
                return this;
              }
              const copy = new Validator_UnitFilter(this);
              copy._hasValidateUnitFilter = false;
              copy._validateUnitFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitFilter(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitFilter(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitFilter} other
   * @returns {Validator_UnitFilter}
   */
  merge(other) {
    const copy = new Validator_UnitFilter(this);
    if (other._hasValidateUnitFilter) {
      copy._hasValidateUnitFilter = true;
      copy._validateUnitFilter = other._validateUnitFilter;
    }
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
Validator_UnitFilter.default = new Validator_UnitFilter();
class Validator_UnitFilter_Builder {
  constructor(value) {
    this._value = new Validator_UnitFilter(value);
  }
  build() {
    return new Validator_UnitFilter(this._value);
  }
  setValidateUnitFilter(value) {
    this._value._hasValidateUnitFilter = true;
    this._value._validateUnitFilter = value;
    return this;
  }
  deleteValidateUnitFilter() {
    this._value._hasValidateUnitFilter = false;
    this._value._validateUnitFilter = null;
    return this;
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
Validator_UnitFilter.Builder = Validator_UnitFilter_Builder;
class Validator_UnitFilter_WithParent {
  /**
   * @param {Validator_UnitFilter} value
   * @param {Validator_UnitFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValidateUnitFilter() {
    if (this._cachedHasValidateUnitFilter === undefined) {
      if (this._value.hasValidateUnitFilter) {
        this._cachedHasValidateUnitFilter = true;
      } else {
        this._cachedHasValidateUnitFilter = this._parent ? this._parent.hasValidateUnitFilter : false;
      }
    }
    return this._cachedHasValidateUnitFilter;
  }
  get validateUnitFilter() {
    if (this._cachedValidateUnitFilter === undefined) {
      if (this._value.hasValidateUnitFilter) {
        this._cachedValidateUnitFilter = this._value.validateUnitFilter;
      } else {
        this._cachedValidateUnitFilter = this._parent ? this._parent.validateUnitFilter : this._value.validateUnitFilter;
      }
    }
    return this._cachedValidateUnitFilter;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new Validator_UnitFilter_WithParent(current, parent);
    return result;
  }
}
Validator_UnitFilter_WithParent.default = new Validator_UnitFilter_WithParent(Validator_UnitFilter.default, null);
Validator_UnitFilter.WithParent = Validator_UnitFilter_WithParent;
class Validator_UnitFilter_Descriptor {
  get validateUnitFilter() {
    if (!this._validateUnitFilter) {
      this._validateUnitFilter = {
        name: "validateUnitFilter",
        Name: "ValidateUnitFilter",
        number: 1,
        protoType: 14,
        protoName: "validate_unit_filter",
        type: dcei_engine_unit_proto.UnitComponent.UnitType,
        options: {
          comments: "Returns true if the specified unit is of this type.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validateUnitFilter;
  }
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 2,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit will be considered by the validator.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.validateUnitFilter,
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValidateUnitFilter",
        Name: "DummyOneofForValidateUnitFilter",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitFilter.descriptor = new Validator_UnitFilter_Descriptor();
class Validator_UnitType {
  get descriptor() {
    return Validator_UnitType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitTypeName = false;
    this._unitTypeName = null;
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasUnitTypeName) return false;
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitType) {
      return value;
    }
    return Validator_UnitType.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitType();
    if (json.unitTypeName != null) {
      result._hasUnitTypeName = true;
      result._unitTypeName = JsonToString.fromJson(json.unitTypeName);
    }
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitTypeName) {
      result.unitTypeName = JsonToString.toJson(this._unitTypeName);
    }
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unitTypeName() {
    return this._hasUnitTypeName ? this._unitTypeName : JsonToString.default;
  }
  get hasUnitTypeName() {
    return this._hasUnitTypeName;
  }
  setUnitTypeName(path, value) {
    return {type: 'SET', path: path.concat(['unitTypeName']), value};
  }
  deleteUnitTypeName(path) {
    return {type: 'DELETE', path: path.concat(['unitTypeName'])};
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitTypeName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitType(this);
              copy._hasUnitTypeName = true;
              copy._unitTypeName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitTypeName) {
                return this;
              }
              const copy = new Validator_UnitType(this);
              copy._hasUnitTypeName = false;
              copy._unitTypeName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitType(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitType(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitType} other
   * @returns {Validator_UnitType}
   */
  merge(other) {
    const copy = new Validator_UnitType(this);
    if (other._hasUnitTypeName) {
      copy._hasUnitTypeName = true;
      copy._unitTypeName = other._unitTypeName;
    }
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
Validator_UnitType.default = new Validator_UnitType();
class Validator_UnitType_Builder {
  constructor(value) {
    this._value = new Validator_UnitType(value);
  }
  build() {
    return new Validator_UnitType(this._value);
  }
  setUnitTypeName(value) {
    this._value._hasUnitTypeName = true;
    this._value._unitTypeName = value;
    return this;
  }
  deleteUnitTypeName() {
    this._value._hasUnitTypeName = false;
    this._value._unitTypeName = null;
    return this;
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
Validator_UnitType.Builder = Validator_UnitType_Builder;
class Validator_UnitType_WithParent {
  /**
   * @param {Validator_UnitType} value
   * @param {Validator_UnitType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitTypeName() {
    if (this._cachedHasUnitTypeName === undefined) {
      if (this._value.hasUnitTypeName) {
        this._cachedHasUnitTypeName = true;
      } else {
        this._cachedHasUnitTypeName = this._parent ? this._parent.hasUnitTypeName : false;
      }
    }
    return this._cachedHasUnitTypeName;
  }
  get unitTypeName() {
    if (this._cachedUnitTypeName === undefined) {
      if (this._value.hasUnitTypeName) {
        this._cachedUnitTypeName = this._value.unitTypeName;
      } else {
        this._cachedUnitTypeName = this._parent ? this._parent.unitTypeName : this._value.unitTypeName;
      }
    }
    return this._cachedUnitTypeName;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new Validator_UnitType_WithParent(current, parent);
    return result;
  }
}
Validator_UnitType_WithParent.default = new Validator_UnitType_WithParent(Validator_UnitType.default, null);
Validator_UnitType.WithParent = Validator_UnitType_WithParent;
class Validator_UnitType_Descriptor {
  get unitTypeName() {
    if (!this._unitTypeName) {
      this._unitTypeName = {
        name: "unitTypeName",
        Name: "UnitTypeName",
        number: 1,
        protoType: 9,
        protoName: "unit_type_name",
        type: JsonToString,
        options: {
          comments: "Returns true if the unit is of this type.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitTypeName;
  }
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 2,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit will be considered by the validator.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitTypeName,
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitTypeName",
        Name: "DummyOneofForUnitTypeName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitType.descriptor = new Validator_UnitType_Descriptor();
class Validator_Combine_CombineOperation {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "AND": return 0;
        case "OR": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Validator_Combine_CombineOperation.fromJson(value);
  }
  static fromReact(e) {
    return Validator_Combine_CombineOperation.fromJson(e);
  }
}
Validator_Combine_CombineOperation.AND = 0;
Validator_Combine_CombineOperation.OR = 1;
Validator_Combine_CombineOperation.default = 0;
Validator_Combine_CombineOperation.values = {
  AND: 0,
  OR: 1,
};
Validator_Combine_CombineOperation.names = {
  0: "AND",
  1: "OR",
};
class Validator_Combine {
  get descriptor() {
    return Validator_Combine.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOperation = false;
    this._operation = null;
    this._validatorList = [];
  }
  isEmpty() {
    if (this._hasOperation) return false;
    if (this._validatorList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_Combine) {
      return value;
    }
    return Validator_Combine.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_Combine();
    if (json.operation != null) {
      result._hasOperation = true;
      result._operation = Validator_Combine_CombineOperation.fromJson(json.operation);
    }
    result._validatorList = JsonToList(json.validatorList, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOperation) {
      result.operation = Validator_Combine_CombineOperation.toJson(this._operation);
    }
    if (this._validatorList.length > 0) {
      result.validatorList = ArrayToJson(this._validatorList, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get operation() {
    return this._hasOperation ? this._operation : Validator_Combine_CombineOperation.default;
  }
  get hasOperation() {
    return this._hasOperation;
  }
  setOperation(path, value) {
    return {type: 'SET', path: path.concat(['operation']), value};
  }
  deleteOperation(path) {
    return {type: 'DELETE', path: path.concat(['operation'])};
  }
  /**
   * @returns {string[]}
   */
  get validatorList() {
    return this._validatorList;
  }
  addValidatorList(path, value) {
    return {type: 'ADD', path: path.concat(['validatorList']), value};
  }
  setValidatorList(path, value) {
    return {type: 'SET', path: path.concat(['validatorList']), value: ArrayToJson(value, JsonToString)};
  }
  setValidatorListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['validatorList', key]), value};
  }
  deleteValidatorList(path) {
    return {type: 'DELETE', path: path.concat(['validatorList'])};
  }
  deleteValidatorListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['validatorList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "operation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_Combine(this);
              copy._hasOperation = true;
              copy._operation = Validator_Combine_CombineOperation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOperation) {
                return this;
              }
              const copy = new Validator_Combine(this);
              copy._hasOperation = false;
              copy._operation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "validatorList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_Combine(this);
              copy._validatorList = [];        for (let i of value) {
                copy._validatorList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Validator_Combine(this);
              copy._validatorList = copy._validatorList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._validatorList.length === 0) {
                return this;
              }
              const copy = new Validator_Combine(this);
              copy._validatorList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._validatorList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Validator_Combine(this);
              copy._validatorList = copy._validatorList.slice();
              copy._validatorList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Validator_Combine(this);
              copy._validatorList = copy._validatorList.slice(0, path[1]).concat(copy._validatorList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._validatorList.length) {
            return this;
          }
          const oldValue = this._validatorList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Validator_Combine(this);
          copy._validatorList = copy._validatorList.slice();
          copy._validatorList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_Combine} other
   * @returns {Validator_Combine}
   */
  merge(other) {
    const copy = new Validator_Combine(this);
    if (other._hasOperation) {
      copy._hasOperation = true;
      copy._operation = other._operation;
    }
    copy._validatorList = this._validatorList.concat(other._validatorList);
    return copy;
  }
}
Validator_Combine.default = new Validator_Combine();
Validator_Combine.CombineOperation = Validator_Combine_CombineOperation;
class Validator_Combine_Builder {
  constructor(value) {
    this._value = new Validator_Combine(value);
  }
  build() {
    return new Validator_Combine(this._value);
  }
  setOperation(value) {
    this._value._hasOperation = true;
    this._value._operation = value;
    return this;
  }
  deleteOperation() {
    this._value._hasOperation = false;
    this._value._operation = null;
    return this;
  }
  addAllValidatorList(values) {
    this._value._validatorList = this._value._validatorList.concat(values);
    return this;
  }
  addValidatorList(value) {
    this._value._validatorList = this._value._validatorList.concat([value]);
    return this;
  }
  setValidatorList(index, value) {
    this._value._validatorList = this._value._validatorList.concat();
    this._value._validatorList[index] = value;
    return this;
  }
  clearValidatorList() {
    this._value._validatorList = [];
    return this;
  }
}
Validator_Combine.Builder = Validator_Combine_Builder;
class Validator_Combine_WithParent {
  /**
   * @param {Validator_Combine} value
   * @param {Validator_Combine_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_Combine.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOperation() {
    if (this._cachedHasOperation === undefined) {
      if (this._value.hasOperation) {
        this._cachedHasOperation = true;
      } else {
        this._cachedHasOperation = this._parent ? this._parent.hasOperation : false;
      }
    }
    return this._cachedHasOperation;
  }
  get operation() {
    if (this._cachedOperation === undefined) {
      if (this._value.hasOperation) {
        this._cachedOperation = this._value.operation;
      } else {
        this._cachedOperation = this._parent ? this._parent.operation : this._value.operation;
      }
    }
    return this._cachedOperation;
  }
  get selfValidatorList() {
    return this._value.validatorList;
  }
  get inherentValidatorList() {
    if (!this._inherentValidatorList) {
      this._inherentValidatorList = this._parent ? this._parent.validatorList : [];
    }
    return this._inherentValidatorList;
  }
  get validatorList() {
    if (!this._allValidatorList) {
      this._allValidatorList = this._parent ? this._parent.validatorList.concat(this.selfValidatorList) : this.selfValidatorList;
    }
    return this._allValidatorList;
  }
  update(current, parent) {
    const result = new Validator_Combine_WithParent(current, parent);
    return result;
  }
}
Validator_Combine_WithParent.default = new Validator_Combine_WithParent(Validator_Combine.default, null);
Validator_Combine.WithParent = Validator_Combine_WithParent;
class Validator_Combine_Descriptor {
  get operation() {
    if (!this._operation) {
      this._operation = {
        name: "operation",
        Name: "Operation",
        number: 1,
        protoType: 14,
        protoName: "operation",
        type: Validator_Combine_CombineOperation,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._operation;
  }
  get validatorList() {
    if (!this._validatorList) {
      this._validatorList = {
        name: "validatorList",
        Name: "ValidatorList",
        number: 2,
        protoType: 9,
        protoName: "validator_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The list of validators to combine.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validatorList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.operation,
        this.validatorList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOperation",
        Name: "DummyOneofForOperation",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_Combine.descriptor = new Validator_Combine_Descriptor();
class Validator_UnitEngaged {
  get descriptor() {
    return Validator_UnitEngaged.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitEngaged) {
      return value;
    }
    return Validator_UnitEngaged.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitEngaged();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitEngaged(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitEngaged(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitEngaged} other
   * @returns {Validator_UnitEngaged}
   */
  merge(other) {
    const copy = new Validator_UnitEngaged(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
Validator_UnitEngaged.default = new Validator_UnitEngaged();
class Validator_UnitEngaged_Builder {
  constructor(value) {
    this._value = new Validator_UnitEngaged(value);
  }
  build() {
    return new Validator_UnitEngaged(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
Validator_UnitEngaged.Builder = Validator_UnitEngaged_Builder;
class Validator_UnitEngaged_WithParent {
  /**
   * @param {Validator_UnitEngaged} value
   * @param {Validator_UnitEngaged_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitEngaged.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new Validator_UnitEngaged_WithParent(current, parent);
    return result;
  }
}
Validator_UnitEngaged_WithParent.default = new Validator_UnitEngaged_WithParent(Validator_UnitEngaged.default, null);
Validator_UnitEngaged.WithParent = Validator_UnitEngaged_WithParent;
class Validator_UnitEngaged_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Using NONE defaults to TARGET_UNIT.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitEngaged.descriptor = new Validator_UnitEngaged_Descriptor();
class Validator_LocationIsLane {
  get descriptor() {
    return Validator_LocationIsLane.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTarget = false;
    this._target = null;
    this._hasIgnoreRallyDisabledLanes = false;
    this._ignoreRallyDisabledLanes = null;
  }
  isEmpty() {
    if (this._hasTarget) return false;
    if (this._hasIgnoreRallyDisabledLanes) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_LocationIsLane) {
      return value;
    }
    return Validator_LocationIsLane.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_LocationIsLane();
    if (json.target != null) {
      result._hasTarget = true;
      result._target = dcei_engine_effect_proto.EffectTarget.Type.fromJson(json.target);
    }
    if (json.ignoreRallyDisabledLanes != null) {
      result._hasIgnoreRallyDisabledLanes = true;
      result._ignoreRallyDisabledLanes = JsonToBoolean.fromJson(json.ignoreRallyDisabledLanes);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTarget) {
      result.target = dcei_engine_effect_proto.EffectTarget.Type.toJson(this._target);
    }
    if (this._hasIgnoreRallyDisabledLanes) {
      result.ignoreRallyDisabledLanes = JsonToBoolean.toJson(this._ignoreRallyDisabledLanes);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : dcei_engine_effect_proto.EffectTarget.Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {boolean}
   */
  get ignoreRallyDisabledLanes() {
    return this._hasIgnoreRallyDisabledLanes ? this._ignoreRallyDisabledLanes : JsonToBoolean.default;
  }
  get hasIgnoreRallyDisabledLanes() {
    return this._hasIgnoreRallyDisabledLanes;
  }
  setIgnoreRallyDisabledLanes(path, value) {
    return {type: 'SET', path: path.concat(['ignoreRallyDisabledLanes']), value};
  }
  deleteIgnoreRallyDisabledLanes(path) {
    return {type: 'DELETE', path: path.concat(['ignoreRallyDisabledLanes'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_LocationIsLane(this);
              copy._hasTarget = true;
              copy._target = dcei_engine_effect_proto.EffectTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new Validator_LocationIsLane(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignoreRallyDisabledLanes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_LocationIsLane(this);
              copy._hasIgnoreRallyDisabledLanes = true;
              copy._ignoreRallyDisabledLanes = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnoreRallyDisabledLanes) {
                return this;
              }
              const copy = new Validator_LocationIsLane(this);
              copy._hasIgnoreRallyDisabledLanes = false;
              copy._ignoreRallyDisabledLanes = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_LocationIsLane} other
   * @returns {Validator_LocationIsLane}
   */
  merge(other) {
    const copy = new Validator_LocationIsLane(this);
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasIgnoreRallyDisabledLanes) {
      copy._hasIgnoreRallyDisabledLanes = true;
      copy._ignoreRallyDisabledLanes = other._ignoreRallyDisabledLanes;
    }
    return copy;
  }
}
Validator_LocationIsLane.default = new Validator_LocationIsLane();
class Validator_LocationIsLane_Builder {
  constructor(value) {
    this._value = new Validator_LocationIsLane(value);
  }
  build() {
    return new Validator_LocationIsLane(this._value);
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setIgnoreRallyDisabledLanes(value) {
    this._value._hasIgnoreRallyDisabledLanes = true;
    this._value._ignoreRallyDisabledLanes = value;
    return this;
  }
  deleteIgnoreRallyDisabledLanes() {
    this._value._hasIgnoreRallyDisabledLanes = false;
    this._value._ignoreRallyDisabledLanes = null;
    return this;
  }
}
Validator_LocationIsLane.Builder = Validator_LocationIsLane_Builder;
class Validator_LocationIsLane_WithParent {
  /**
   * @param {Validator_LocationIsLane} value
   * @param {Validator_LocationIsLane_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_LocationIsLane.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasIgnoreRallyDisabledLanes() {
    if (this._cachedHasIgnoreRallyDisabledLanes === undefined) {
      if (this._value.hasIgnoreRallyDisabledLanes) {
        this._cachedHasIgnoreRallyDisabledLanes = true;
      } else {
        this._cachedHasIgnoreRallyDisabledLanes = this._parent ? this._parent.hasIgnoreRallyDisabledLanes : false;
      }
    }
    return this._cachedHasIgnoreRallyDisabledLanes;
  }
  get ignoreRallyDisabledLanes() {
    if (this._cachedIgnoreRallyDisabledLanes === undefined) {
      if (this._value.hasIgnoreRallyDisabledLanes) {
        this._cachedIgnoreRallyDisabledLanes = this._value.ignoreRallyDisabledLanes;
      } else {
        this._cachedIgnoreRallyDisabledLanes = this._parent ? this._parent.ignoreRallyDisabledLanes : this._value.ignoreRallyDisabledLanes;
      }
    }
    return this._cachedIgnoreRallyDisabledLanes;
  }
  update(current, parent) {
    const result = new Validator_LocationIsLane_WithParent(current, parent);
    return result;
  }
}
Validator_LocationIsLane_WithParent.default = new Validator_LocationIsLane_WithParent(Validator_LocationIsLane.default, null);
Validator_LocationIsLane.WithParent = Validator_LocationIsLane_WithParent;
class Validator_LocationIsLane_Descriptor {
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 1,
        protoType: 14,
        protoName: "target",
        type: dcei_engine_effect_proto.EffectTarget.Type,
        options: {
          comments: "Which point to check.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get ignoreRallyDisabledLanes() {
    if (!this._ignoreRallyDisabledLanes) {
      this._ignoreRallyDisabledLanes = {
        name: "ignoreRallyDisabledLanes",
        Name: "IgnoreRallyDisabledLanes",
        number: 2,
        protoType: 8,
        protoName: "ignore_rally_disabled_lanes",
        type: JsonToBoolean,
        options: {
          comments: "If enabled, routes using the \"Disable Rally\" flag won\'t be considered.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignoreRallyDisabledLanes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.target,
        this.ignoreRallyDisabledLanes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnoreRallyDisabledLanes",
        Name: "DummyOneofForIgnoreRallyDisabledLanes",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_LocationIsLane.descriptor = new Validator_LocationIsLane_Descriptor();
class Validator_UnitAiBehavior {
  get descriptor() {
    return Validator_UnitAiBehavior.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehaviorType = false;
    this._behaviorType = null;
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasBehaviorType) return false;
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitAiBehavior) {
      return value;
    }
    return Validator_UnitAiBehavior.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitAiBehavior();
    if (json.behaviorType != null) {
      result._hasBehaviorType = true;
      result._behaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.fromJson(json.behaviorType);
    }
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehaviorType) {
      result.behaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.toJson(this._behaviorType);
    }
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get behaviorType() {
    return this._hasBehaviorType ? this._behaviorType : dcei_engine_unit_proto.BehaviorComponent.BehaviorType.default;
  }
  get hasBehaviorType() {
    return this._hasBehaviorType;
  }
  setBehaviorType(path, value) {
    return {type: 'SET', path: path.concat(['behaviorType']), value};
  }
  deleteBehaviorType(path) {
    return {type: 'DELETE', path: path.concat(['behaviorType'])};
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behaviorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitAiBehavior(this);
              copy._hasBehaviorType = true;
              copy._behaviorType = dcei_engine_unit_proto.BehaviorComponent.BehaviorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehaviorType) {
                return this;
              }
              const copy = new Validator_UnitAiBehavior(this);
              copy._hasBehaviorType = false;
              copy._behaviorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitAiBehavior(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitAiBehavior(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitAiBehavior} other
   * @returns {Validator_UnitAiBehavior}
   */
  merge(other) {
    const copy = new Validator_UnitAiBehavior(this);
    if (other._hasBehaviorType) {
      copy._hasBehaviorType = true;
      copy._behaviorType = other._behaviorType;
    }
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
Validator_UnitAiBehavior.default = new Validator_UnitAiBehavior();
class Validator_UnitAiBehavior_Builder {
  constructor(value) {
    this._value = new Validator_UnitAiBehavior(value);
  }
  build() {
    return new Validator_UnitAiBehavior(this._value);
  }
  setBehaviorType(value) {
    this._value._hasBehaviorType = true;
    this._value._behaviorType = value;
    return this;
  }
  deleteBehaviorType() {
    this._value._hasBehaviorType = false;
    this._value._behaviorType = null;
    return this;
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
Validator_UnitAiBehavior.Builder = Validator_UnitAiBehavior_Builder;
class Validator_UnitAiBehavior_WithParent {
  /**
   * @param {Validator_UnitAiBehavior} value
   * @param {Validator_UnitAiBehavior_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitAiBehavior.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehaviorType() {
    if (this._cachedHasBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedHasBehaviorType = true;
      } else {
        this._cachedHasBehaviorType = this._parent ? this._parent.hasBehaviorType : false;
      }
    }
    return this._cachedHasBehaviorType;
  }
  get behaviorType() {
    if (this._cachedBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedBehaviorType = this._value.behaviorType;
      } else {
        this._cachedBehaviorType = this._parent ? this._parent.behaviorType : this._value.behaviorType;
      }
    }
    return this._cachedBehaviorType;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new Validator_UnitAiBehavior_WithParent(current, parent);
    return result;
  }
}
Validator_UnitAiBehavior_WithParent.default = new Validator_UnitAiBehavior_WithParent(Validator_UnitAiBehavior.default, null);
Validator_UnitAiBehavior.WithParent = Validator_UnitAiBehavior_WithParent;
class Validator_UnitAiBehavior_Descriptor {
  get behaviorType() {
    if (!this._behaviorType) {
      this._behaviorType = {
        name: "behaviorType",
        Name: "BehaviorType",
        number: 1,
        protoType: 14,
        protoName: "behavior_type",
        type: dcei_engine_unit_proto.BehaviorComponent.BehaviorType,
        options: {
          comments: "Returns true if the unit has this AI behavior type.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorType;
  }
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 2,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit will be considered by the validator.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behaviorType,
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehaviorType",
        Name: "DummyOneofForBehaviorType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitAiBehavior.descriptor = new Validator_UnitAiBehavior_Descriptor();
class Validator_UnitStats {
  get descriptor() {
    return Validator_UnitStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasAir = false;
    this._air = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasAir) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitStats) {
      return value;
    }
    return Validator_UnitStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitStats();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    if (json.air != null) {
      result._hasAir = true;
      result._air = dcei_engine_effect_proto.SearchFilter.Flag.fromJson(json.air);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    if (this._hasAir) {
      result.air = dcei_engine_effect_proto.SearchFilter.Flag.toJson(this._air);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get air() {
    return this._hasAir ? this._air : dcei_engine_effect_proto.SearchFilter.Flag.default;
  }
  get hasAir() {
    return this._hasAir;
  }
  setAir(path, value) {
    return {type: 'SET', path: path.concat(['air']), value};
  }
  deleteAir(path) {
    return {type: 'DELETE', path: path.concat(['air'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitStats(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitStats(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "air": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitStats(this);
              copy._hasAir = true;
              copy._air = dcei_engine_effect_proto.SearchFilter.Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAir) {
                return this;
              }
              const copy = new Validator_UnitStats(this);
              copy._hasAir = false;
              copy._air = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitStats} other
   * @returns {Validator_UnitStats}
   */
  merge(other) {
    const copy = new Validator_UnitStats(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasAir) {
      copy._hasAir = true;
      copy._air = other._air;
    }
    return copy;
  }
}
Validator_UnitStats.default = new Validator_UnitStats();
class Validator_UnitStats_Builder {
  constructor(value) {
    this._value = new Validator_UnitStats(value);
  }
  build() {
    return new Validator_UnitStats(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setAir(value) {
    this._value._hasAir = true;
    this._value._air = value;
    return this;
  }
  deleteAir() {
    this._value._hasAir = false;
    this._value._air = null;
    return this;
  }
}
Validator_UnitStats.Builder = Validator_UnitStats_Builder;
class Validator_UnitStats_WithParent {
  /**
   * @param {Validator_UnitStats} value
   * @param {Validator_UnitStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasAir() {
    if (this._cachedHasAir === undefined) {
      if (this._value.hasAir) {
        this._cachedHasAir = true;
      } else {
        this._cachedHasAir = this._parent ? this._parent.hasAir : false;
      }
    }
    return this._cachedHasAir;
  }
  get air() {
    if (this._cachedAir === undefined) {
      if (this._value.hasAir) {
        this._cachedAir = this._value.air;
      } else {
        this._cachedAir = this._parent ? this._parent.air : this._value.air;
      }
    }
    return this._cachedAir;
  }
  update(current, parent) {
    const result = new Validator_UnitStats_WithParent(current, parent);
    return result;
  }
}
Validator_UnitStats_WithParent.default = new Validator_UnitStats_WithParent(Validator_UnitStats.default, null);
Validator_UnitStats.WithParent = Validator_UnitStats_WithParent;
class Validator_UnitStats_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit will be considered by the validator.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get air() {
    if (!this._air) {
      this._air = {
        name: "air",
        Name: "Air",
        number: 2,
        protoType: 14,
        protoName: "air",
        type: dcei_engine_effect_proto.SearchFilter.Flag,
        options: {
          comments: "Returns true if the unit matches this filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._air;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.air,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAir",
        Name: "DummyOneofForAir",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitStats.descriptor = new Validator_UnitStats_Descriptor();
class Validator_PointOnNavmesh {
  get descriptor() {
    return Validator_PointOnNavmesh.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTarget = false;
    this._target = null;
  }
  isEmpty() {
    if (this._hasTarget) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_PointOnNavmesh) {
      return value;
    }
    return Validator_PointOnNavmesh.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_PointOnNavmesh();
    if (json.target != null) {
      result._hasTarget = true;
      result._target = dcei_engine_effect_proto.EffectTarget.Type.fromJson(json.target);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTarget) {
      result.target = dcei_engine_effect_proto.EffectTarget.Type.toJson(this._target);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : dcei_engine_effect_proto.EffectTarget.Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_PointOnNavmesh(this);
              copy._hasTarget = true;
              copy._target = dcei_engine_effect_proto.EffectTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new Validator_PointOnNavmesh(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_PointOnNavmesh} other
   * @returns {Validator_PointOnNavmesh}
   */
  merge(other) {
    const copy = new Validator_PointOnNavmesh(this);
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    return copy;
  }
}
Validator_PointOnNavmesh.default = new Validator_PointOnNavmesh();
class Validator_PointOnNavmesh_Builder {
  constructor(value) {
    this._value = new Validator_PointOnNavmesh(value);
  }
  build() {
    return new Validator_PointOnNavmesh(this._value);
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
}
Validator_PointOnNavmesh.Builder = Validator_PointOnNavmesh_Builder;
class Validator_PointOnNavmesh_WithParent {
  /**
   * @param {Validator_PointOnNavmesh} value
   * @param {Validator_PointOnNavmesh_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_PointOnNavmesh.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  update(current, parent) {
    const result = new Validator_PointOnNavmesh_WithParent(current, parent);
    return result;
  }
}
Validator_PointOnNavmesh_WithParent.default = new Validator_PointOnNavmesh_WithParent(Validator_PointOnNavmesh.default, null);
Validator_PointOnNavmesh.WithParent = Validator_PointOnNavmesh_WithParent;
class Validator_PointOnNavmesh_Descriptor {
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 1,
        protoType: 14,
        protoName: "target",
        type: dcei_engine_effect_proto.EffectTarget.Type,
        options: {
          comments: "Which point to check.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.target,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_PointOnNavmesh.descriptor = new Validator_PointOnNavmesh_Descriptor();
class Validator_UnitIsMoving {
  get descriptor() {
    return Validator_UnitIsMoving.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_UnitIsMoving) {
      return value;
    }
    return Validator_UnitIsMoving.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_UnitIsMoving();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : dcei_engine_effect_proto.EffectUnitTarget.Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_UnitIsMoving(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = dcei_engine_effect_proto.EffectUnitTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new Validator_UnitIsMoving(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_UnitIsMoving} other
   * @returns {Validator_UnitIsMoving}
   */
  merge(other) {
    const copy = new Validator_UnitIsMoving(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
Validator_UnitIsMoving.default = new Validator_UnitIsMoving();
class Validator_UnitIsMoving_Builder {
  constructor(value) {
    this._value = new Validator_UnitIsMoving(value);
  }
  build() {
    return new Validator_UnitIsMoving(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
Validator_UnitIsMoving.Builder = Validator_UnitIsMoving_Builder;
class Validator_UnitIsMoving_WithParent {
  /**
   * @param {Validator_UnitIsMoving} value
   * @param {Validator_UnitIsMoving_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_UnitIsMoving.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new Validator_UnitIsMoving_WithParent(current, parent);
    return result;
  }
}
Validator_UnitIsMoving_WithParent.default = new Validator_UnitIsMoving_WithParent(Validator_UnitIsMoving.default, null);
Validator_UnitIsMoving.WithParent = Validator_UnitIsMoving_WithParent;
class Validator_UnitIsMoving_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: dcei_engine_effect_proto.EffectUnitTarget.Type,
        options: {
          comments: "Which unit to check. Using NONE defaults to TARGET_UNIT.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_UnitIsMoving.descriptor = new Validator_UnitIsMoving_Descriptor();
class Validator_EffectCriticalHit {
  get descriptor() {
    return Validator_EffectCriticalHit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_EffectCriticalHit) {
      return value;
    }
    return Validator_EffectCriticalHit.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_EffectCriticalHit();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {Validator_EffectCriticalHit} other
   * @returns {Validator_EffectCriticalHit}
   */
  merge(other) {
    const copy = new Validator_EffectCriticalHit(this);
    return copy;
  }
}
Validator_EffectCriticalHit.default = new Validator_EffectCriticalHit();
class Validator_EffectCriticalHit_Builder {
  constructor(value) {
    this._value = new Validator_EffectCriticalHit(value);
  }
  build() {
    return new Validator_EffectCriticalHit(this._value);
  }
}
Validator_EffectCriticalHit.Builder = Validator_EffectCriticalHit_Builder;
class Validator_EffectCriticalHit_WithParent {
  /**
   * @param {Validator_EffectCriticalHit} value
   * @param {Validator_EffectCriticalHit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_EffectCriticalHit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new Validator_EffectCriticalHit_WithParent(current, parent);
    return result;
  }
}
Validator_EffectCriticalHit_WithParent.default = new Validator_EffectCriticalHit_WithParent(Validator_EffectCriticalHit.default, null);
Validator_EffectCriticalHit.WithParent = Validator_EffectCriticalHit_WithParent;
class Validator_EffectCriticalHit_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
Validator_EffectCriticalHit.descriptor = new Validator_EffectCriticalHit_Descriptor();
class Validator_WaveStarted {
  get descriptor() {
    return Validator_WaveStarted.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_WaveStarted) {
      return value;
    }
    return Validator_WaveStarted.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_WaveStarted();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {Validator_WaveStarted} other
   * @returns {Validator_WaveStarted}
   */
  merge(other) {
    const copy = new Validator_WaveStarted(this);
    return copy;
  }
}
Validator_WaveStarted.default = new Validator_WaveStarted();
class Validator_WaveStarted_Builder {
  constructor(value) {
    this._value = new Validator_WaveStarted(value);
  }
  build() {
    return new Validator_WaveStarted(this._value);
  }
}
Validator_WaveStarted.Builder = Validator_WaveStarted_Builder;
class Validator_WaveStarted_WithParent {
  /**
   * @param {Validator_WaveStarted} value
   * @param {Validator_WaveStarted_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_WaveStarted.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new Validator_WaveStarted_WithParent(current, parent);
    return result;
  }
}
Validator_WaveStarted_WithParent.default = new Validator_WaveStarted_WithParent(Validator_WaveStarted.default, null);
Validator_WaveStarted.WithParent = Validator_WaveStarted_WithParent;
class Validator_WaveStarted_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
Validator_WaveStarted.descriptor = new Validator_WaveStarted_Descriptor();
class Validator_PointOnCliff {
  get descriptor() {
    return Validator_PointOnCliff.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLocation = false;
    this._location = null;
  }
  isEmpty() {
    if (this._hasLocation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator_PointOnCliff) {
      return value;
    }
    return Validator_PointOnCliff.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator_PointOnCliff();
    if (json.location != null) {
      result._hasLocation = true;
      result._location = dcei_engine_effect_proto.EffectTarget.Type.fromJson(json.location);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLocation) {
      result.location = dcei_engine_effect_proto.EffectTarget.Type.toJson(this._location);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : dcei_engine_effect_proto.EffectTarget.Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator_PointOnCliff(this);
              copy._hasLocation = true;
              copy._location = dcei_engine_effect_proto.EffectTarget.Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new Validator_PointOnCliff(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator_PointOnCliff} other
   * @returns {Validator_PointOnCliff}
   */
  merge(other) {
    const copy = new Validator_PointOnCliff(this);
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    return copy;
  }
}
Validator_PointOnCliff.default = new Validator_PointOnCliff();
class Validator_PointOnCliff_Builder {
  constructor(value) {
    this._value = new Validator_PointOnCliff(value);
  }
  build() {
    return new Validator_PointOnCliff(this._value);
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
}
Validator_PointOnCliff.Builder = Validator_PointOnCliff_Builder;
class Validator_PointOnCliff_WithParent {
  /**
   * @param {Validator_PointOnCliff} value
   * @param {Validator_PointOnCliff_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator_PointOnCliff.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  update(current, parent) {
    const result = new Validator_PointOnCliff_WithParent(current, parent);
    return result;
  }
}
Validator_PointOnCliff_WithParent.default = new Validator_PointOnCliff_WithParent(Validator_PointOnCliff.default, null);
Validator_PointOnCliff.WithParent = Validator_PointOnCliff_WithParent;
class Validator_PointOnCliff_Descriptor {
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 1,
        protoType: 14,
        protoName: "location",
        type: dcei_engine_effect_proto.EffectTarget.Type,
        options: {
          comments: "Which point to check.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.location,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator_PointOnCliff.descriptor = new Validator_PointOnCliff_Descriptor();
class Validator_ValidatorValueType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "ABSOLUTE": return 1;
        case "PERCENTAGE": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Validator_ValidatorValueType.fromJson(value);
  }
  static fromReact(e) {
    return Validator_ValidatorValueType.fromJson(e);
  }
}
Validator_ValidatorValueType.NONE = 0;
Validator_ValidatorValueType.ABSOLUTE = 1;
Validator_ValidatorValueType.PERCENTAGE = 2;
Validator_ValidatorValueType.default = 0;
Validator_ValidatorValueType.values = {
  NONE: 0,
  ABSOLUTE: 1,
  PERCENTAGE: 2,
};
Validator_ValidatorValueType.names = {
  0: "NONE",
  1: "ABSOLUTE",
  2: "PERCENTAGE",
};
export class Validator {
  get descriptor() {
    return Validator.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasNegate = false;
    this._negate = null;
    this._oneofValidatorTypeCase = 0;
    this._oneofValidatorTypeValue = null;
    this._hasComment = false;
    this._comment = null;
  }
  isEmpty() {
    if (this._hasNegate) return false;
    if (this._oneofValidatorTypeCase !== 0) return false;
    if (this._hasComment) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Validator) {
      return value;
    }
    return Validator.fromJson(value);
  }
  static fromJson(json) {
    const result = new Validator();
    if (json.negate != null) {
      result._hasNegate = true;
      result._negate = JsonToBoolean.fromJson(json.negate);
    }
    if (json.unitWithinRange != null) {
      result._oneofValidatorTypeCase = 2;
      result._oneofValidatorTypeValue = Validator_UnitWithinRange.fromJson(json.unitWithinRange);
    }
    if (json.nearbyUnitHealth != null) {
      result._oneofValidatorTypeCase = 3;
      result._oneofValidatorTypeValue = Validator_NearbyUnitHealth.fromJson(json.nearbyUnitHealth);
    }
    if (json.healthValue != null) {
      result._oneofValidatorTypeCase = 4;
      result._oneofValidatorTypeValue = Validator_HealthValue.fromJson(json.healthValue);
    }
    if (json.troopAmount != null) {
      result._oneofValidatorTypeCase = 5;
      result._oneofValidatorTypeValue = Validator_TroopAmount.fromJson(json.troopAmount);
    }
    if (json.unitFilter != null) {
      result._oneofValidatorTypeCase = 6;
      result._oneofValidatorTypeValue = Validator_UnitFilter.fromJson(json.unitFilter);
    }
    if (json.combine != null) {
      result._oneofValidatorTypeCase = 7;
      result._oneofValidatorTypeValue = Validator_Combine.fromJson(json.combine);
    }
    if (json.unitEngaged != null) {
      result._oneofValidatorTypeCase = 8;
      result._oneofValidatorTypeValue = Validator_UnitEngaged.fromJson(json.unitEngaged);
    }
    if (json.unitType != null) {
      result._oneofValidatorTypeCase = 9;
      result._oneofValidatorTypeValue = Validator_UnitType.fromJson(json.unitType);
    }
    if (json.locationIsLane != null) {
      result._oneofValidatorTypeCase = 10;
      result._oneofValidatorTypeValue = Validator_LocationIsLane.fromJson(json.locationIsLane);
    }
    if (json.unitAiBehavior != null) {
      result._oneofValidatorTypeCase = 11;
      result._oneofValidatorTypeValue = Validator_UnitAiBehavior.fromJson(json.unitAiBehavior);
    }
    if (json.waveStarted != null) {
      result._oneofValidatorTypeCase = 12;
      result._oneofValidatorTypeValue = Validator_WaveStarted.fromJson(json.waveStarted);
    }
    if (json.unitStats != null) {
      result._oneofValidatorTypeCase = 13;
      result._oneofValidatorTypeValue = Validator_UnitStats.fromJson(json.unitStats);
    }
    if (json.pointOnNavmesh != null) {
      result._oneofValidatorTypeCase = 14;
      result._oneofValidatorTypeValue = Validator_PointOnNavmesh.fromJson(json.pointOnNavmesh);
    }
    if (json.effectCriticalHit != null) {
      result._oneofValidatorTypeCase = 15;
      result._oneofValidatorTypeValue = Validator_EffectCriticalHit.fromJson(json.effectCriticalHit);
    }
    if (json.unitIsMoving != null) {
      result._oneofValidatorTypeCase = 16;
      result._oneofValidatorTypeValue = Validator_UnitIsMoving.fromJson(json.unitIsMoving);
    }
    if (json.pointOnCliff != null) {
      result._oneofValidatorTypeCase = 17;
      result._oneofValidatorTypeValue = Validator_PointOnCliff.fromJson(json.pointOnCliff);
    }
    if (json.expression != null) {
      result._oneofValidatorTypeCase = 101;
      result._oneofValidatorTypeValue = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromJson(json.expression);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasNegate) {
      result.negate = JsonToBoolean.toJson(this._negate);
    }
    switch (this._oneofValidatorTypeCase) {
      case 2:
        result.unitWithinRange = Validator_UnitWithinRange.toJson(this._oneofValidatorTypeValue);
        break;
      case 3:
        result.nearbyUnitHealth = Validator_NearbyUnitHealth.toJson(this._oneofValidatorTypeValue);
        break;
      case 4:
        result.healthValue = Validator_HealthValue.toJson(this._oneofValidatorTypeValue);
        break;
      case 5:
        result.troopAmount = Validator_TroopAmount.toJson(this._oneofValidatorTypeValue);
        break;
      case 6:
        result.unitFilter = Validator_UnitFilter.toJson(this._oneofValidatorTypeValue);
        break;
      case 7:
        result.combine = Validator_Combine.toJson(this._oneofValidatorTypeValue);
        break;
      case 8:
        result.unitEngaged = Validator_UnitEngaged.toJson(this._oneofValidatorTypeValue);
        break;
      case 9:
        result.unitType = Validator_UnitType.toJson(this._oneofValidatorTypeValue);
        break;
      case 10:
        result.locationIsLane = Validator_LocationIsLane.toJson(this._oneofValidatorTypeValue);
        break;
      case 11:
        result.unitAiBehavior = Validator_UnitAiBehavior.toJson(this._oneofValidatorTypeValue);
        break;
      case 12:
        result.waveStarted = Validator_WaveStarted.toJson(this._oneofValidatorTypeValue);
        break;
      case 13:
        result.unitStats = Validator_UnitStats.toJson(this._oneofValidatorTypeValue);
        break;
      case 14:
        result.pointOnNavmesh = Validator_PointOnNavmesh.toJson(this._oneofValidatorTypeValue);
        break;
      case 15:
        result.effectCriticalHit = Validator_EffectCriticalHit.toJson(this._oneofValidatorTypeValue);
        break;
      case 16:
        result.unitIsMoving = Validator_UnitIsMoving.toJson(this._oneofValidatorTypeValue);
        break;
      case 17:
        result.pointOnCliff = Validator_PointOnCliff.toJson(this._oneofValidatorTypeValue);
        break;
      case 101:
        result.expression = dcei_engine_expression_proto.ValidatorExpressions.Expression.toJson(this._oneofValidatorTypeValue);
        break;
      default:
        break;
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get negate() {
    return this._hasNegate ? this._negate : JsonToBoolean.default;
  }
  get hasNegate() {
    return this._hasNegate;
  }
  setNegate(path, value) {
    return {type: 'SET', path: path.concat(['negate']), value};
  }
  deleteNegate(path) {
    return {type: 'DELETE', path: path.concat(['negate'])};
  }
  get oneofValidatorTypeCase() {
    return this._oneofValidatorTypeCase;
  }
  deleteOneofValidatorType(path) {
    switch (this._oneofValidatorTypeCase) {
      default:
      case 2: {
        return {type: 'DELETE', path: path.concat(['unitWithinRange'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['nearbyUnitHealth'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['healthValue'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['troopAmount'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['unitFilter'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['combine'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['unitEngaged'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['unitType'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['locationIsLane'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['unitAiBehavior'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['waveStarted'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['unitStats'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['pointOnNavmesh'])};
      }
      case 15: {
        return {type: 'DELETE', path: path.concat(['effectCriticalHit'])};
      }
      case 16: {
        return {type: 'DELETE', path: path.concat(['unitIsMoving'])};
      }
      case 17: {
        return {type: 'DELETE', path: path.concat(['pointOnCliff'])};
      }
      case 101: {
        return {type: 'DELETE', path: path.concat(['expression'])};
      }
    }
  }
  /**
   * @returns {Validator_UnitWithinRange}
   */
  get unitWithinRange() {
    return this._oneofValidatorTypeCase === 2 ? this._oneofValidatorTypeValue : Validator_UnitWithinRange.default;
  }
  setUnitWithinRange(path, value) {
    return {type: 'SET', path: path.concat(['unitWithinRange']), value: value.toJson()};
  }
  deleteUnitWithinRange(path) {
    return {type: 'DELETE', path: path.concat(['unitWithinRange'])};
  }
  /**
   * @returns {Validator_NearbyUnitHealth}
   */
  get nearbyUnitHealth() {
    return this._oneofValidatorTypeCase === 3 ? this._oneofValidatorTypeValue : Validator_NearbyUnitHealth.default;
  }
  setNearbyUnitHealth(path, value) {
    return {type: 'SET', path: path.concat(['nearbyUnitHealth']), value: value.toJson()};
  }
  deleteNearbyUnitHealth(path) {
    return {type: 'DELETE', path: path.concat(['nearbyUnitHealth'])};
  }
  /**
   * @returns {Validator_HealthValue}
   */
  get healthValue() {
    return this._oneofValidatorTypeCase === 4 ? this._oneofValidatorTypeValue : Validator_HealthValue.default;
  }
  setHealthValue(path, value) {
    return {type: 'SET', path: path.concat(['healthValue']), value: value.toJson()};
  }
  deleteHealthValue(path) {
    return {type: 'DELETE', path: path.concat(['healthValue'])};
  }
  /**
   * @returns {Validator_TroopAmount}
   */
  get troopAmount() {
    return this._oneofValidatorTypeCase === 5 ? this._oneofValidatorTypeValue : Validator_TroopAmount.default;
  }
  setTroopAmount(path, value) {
    return {type: 'SET', path: path.concat(['troopAmount']), value: value.toJson()};
  }
  deleteTroopAmount(path) {
    return {type: 'DELETE', path: path.concat(['troopAmount'])};
  }
  /**
   * @returns {Validator_UnitFilter}
   */
  get unitFilter() {
    return this._oneofValidatorTypeCase === 6 ? this._oneofValidatorTypeValue : Validator_UnitFilter.default;
  }
  setUnitFilter(path, value) {
    return {type: 'SET', path: path.concat(['unitFilter']), value: value.toJson()};
  }
  deleteUnitFilter(path) {
    return {type: 'DELETE', path: path.concat(['unitFilter'])};
  }
  /**
   * @returns {Validator_Combine}
   */
  get combine() {
    return this._oneofValidatorTypeCase === 7 ? this._oneofValidatorTypeValue : Validator_Combine.default;
  }
  setCombine(path, value) {
    return {type: 'SET', path: path.concat(['combine']), value: value.toJson()};
  }
  deleteCombine(path) {
    return {type: 'DELETE', path: path.concat(['combine'])};
  }
  /**
   * @returns {Validator_UnitEngaged}
   */
  get unitEngaged() {
    return this._oneofValidatorTypeCase === 8 ? this._oneofValidatorTypeValue : Validator_UnitEngaged.default;
  }
  setUnitEngaged(path, value) {
    return {type: 'SET', path: path.concat(['unitEngaged']), value: value.toJson()};
  }
  deleteUnitEngaged(path) {
    return {type: 'DELETE', path: path.concat(['unitEngaged'])};
  }
  /**
   * @returns {Validator_UnitType}
   */
  get unitType() {
    return this._oneofValidatorTypeCase === 9 ? this._oneofValidatorTypeValue : Validator_UnitType.default;
  }
  setUnitType(path, value) {
    return {type: 'SET', path: path.concat(['unitType']), value: value.toJson()};
  }
  deleteUnitType(path) {
    return {type: 'DELETE', path: path.concat(['unitType'])};
  }
  /**
   * @returns {Validator_LocationIsLane}
   */
  get locationIsLane() {
    return this._oneofValidatorTypeCase === 10 ? this._oneofValidatorTypeValue : Validator_LocationIsLane.default;
  }
  setLocationIsLane(path, value) {
    return {type: 'SET', path: path.concat(['locationIsLane']), value: value.toJson()};
  }
  deleteLocationIsLane(path) {
    return {type: 'DELETE', path: path.concat(['locationIsLane'])};
  }
  /**
   * @returns {Validator_UnitAiBehavior}
   */
  get unitAiBehavior() {
    return this._oneofValidatorTypeCase === 11 ? this._oneofValidatorTypeValue : Validator_UnitAiBehavior.default;
  }
  setUnitAiBehavior(path, value) {
    return {type: 'SET', path: path.concat(['unitAiBehavior']), value: value.toJson()};
  }
  deleteUnitAiBehavior(path) {
    return {type: 'DELETE', path: path.concat(['unitAiBehavior'])};
  }
  /**
   * @returns {Validator_WaveStarted}
   */
  get waveStarted() {
    return this._oneofValidatorTypeCase === 12 ? this._oneofValidatorTypeValue : Validator_WaveStarted.default;
  }
  setWaveStarted(path, value) {
    return {type: 'SET', path: path.concat(['waveStarted']), value: value.toJson()};
  }
  deleteWaveStarted(path) {
    return {type: 'DELETE', path: path.concat(['waveStarted'])};
  }
  /**
   * @returns {Validator_UnitStats}
   */
  get unitStats() {
    return this._oneofValidatorTypeCase === 13 ? this._oneofValidatorTypeValue : Validator_UnitStats.default;
  }
  setUnitStats(path, value) {
    return {type: 'SET', path: path.concat(['unitStats']), value: value.toJson()};
  }
  deleteUnitStats(path) {
    return {type: 'DELETE', path: path.concat(['unitStats'])};
  }
  /**
   * @returns {Validator_PointOnNavmesh}
   */
  get pointOnNavmesh() {
    return this._oneofValidatorTypeCase === 14 ? this._oneofValidatorTypeValue : Validator_PointOnNavmesh.default;
  }
  setPointOnNavmesh(path, value) {
    return {type: 'SET', path: path.concat(['pointOnNavmesh']), value: value.toJson()};
  }
  deletePointOnNavmesh(path) {
    return {type: 'DELETE', path: path.concat(['pointOnNavmesh'])};
  }
  /**
   * @returns {Validator_EffectCriticalHit}
   */
  get effectCriticalHit() {
    return this._oneofValidatorTypeCase === 15 ? this._oneofValidatorTypeValue : Validator_EffectCriticalHit.default;
  }
  setEffectCriticalHit(path, value) {
    return {type: 'SET', path: path.concat(['effectCriticalHit']), value: value.toJson()};
  }
  deleteEffectCriticalHit(path) {
    return {type: 'DELETE', path: path.concat(['effectCriticalHit'])};
  }
  /**
   * @returns {Validator_UnitIsMoving}
   */
  get unitIsMoving() {
    return this._oneofValidatorTypeCase === 16 ? this._oneofValidatorTypeValue : Validator_UnitIsMoving.default;
  }
  setUnitIsMoving(path, value) {
    return {type: 'SET', path: path.concat(['unitIsMoving']), value: value.toJson()};
  }
  deleteUnitIsMoving(path) {
    return {type: 'DELETE', path: path.concat(['unitIsMoving'])};
  }
  /**
   * @returns {Validator_PointOnCliff}
   */
  get pointOnCliff() {
    return this._oneofValidatorTypeCase === 17 ? this._oneofValidatorTypeValue : Validator_PointOnCliff.default;
  }
  setPointOnCliff(path, value) {
    return {type: 'SET', path: path.concat(['pointOnCliff']), value: value.toJson()};
  }
  deletePointOnCliff(path) {
    return {type: 'DELETE', path: path.concat(['pointOnCliff'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression}
   */
  get expression() {
    return this._oneofValidatorTypeCase === 101 ? this._oneofValidatorTypeValue : dcei_engine_expression_proto.ValidatorExpressions.Expression.default;
  }
  setExpression(path, value) {
    return {type: 'SET', path: path.concat(['expression']), value: value.toJson()};
  }
  deleteExpression(path) {
    return {type: 'DELETE', path: path.concat(['expression'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "negate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._hasNegate = true;
              copy._negate = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNegate) {
                return this;
              }
              const copy = new Validator(this);
              copy._hasNegate = false;
              copy._negate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitWithinRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 2;
              copy._oneofValidatorTypeValue = Validator_UnitWithinRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 2) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 2) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 2;
            copy._oneofValidatorTypeValue = Validator_UnitWithinRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWithinRange.apply(type, path.slice(1), value);
          if (newValue === this.unitWithinRange) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 2;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "nearbyUnitHealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 3;
              copy._oneofValidatorTypeValue = Validator_NearbyUnitHealth.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 3) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 3) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 3;
            copy._oneofValidatorTypeValue = Validator_NearbyUnitHealth.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.nearbyUnitHealth.apply(type, path.slice(1), value);
          if (newValue === this.nearbyUnitHealth) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 3;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "healthValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 4;
              copy._oneofValidatorTypeValue = Validator_HealthValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 4) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 4) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 4;
            copy._oneofValidatorTypeValue = Validator_HealthValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.healthValue.apply(type, path.slice(1), value);
          if (newValue === this.healthValue) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 4;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "troopAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 5;
              copy._oneofValidatorTypeValue = Validator_TroopAmount.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 5) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 5) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 5;
            copy._oneofValidatorTypeValue = Validator_TroopAmount.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.troopAmount.apply(type, path.slice(1), value);
          if (newValue === this.troopAmount) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 5;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 6;
              copy._oneofValidatorTypeValue = Validator_UnitFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 6) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 6) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 6;
            copy._oneofValidatorTypeValue = Validator_UnitFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitFilter.apply(type, path.slice(1), value);
          if (newValue === this.unitFilter) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 6;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "combine": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 7;
              copy._oneofValidatorTypeValue = Validator_Combine.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 7) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 7) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 7;
            copy._oneofValidatorTypeValue = Validator_Combine.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.combine.apply(type, path.slice(1), value);
          if (newValue === this.combine) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 7;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitEngaged": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 8;
              copy._oneofValidatorTypeValue = Validator_UnitEngaged.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 8) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 8) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 8;
            copy._oneofValidatorTypeValue = Validator_UnitEngaged.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitEngaged.apply(type, path.slice(1), value);
          if (newValue === this.unitEngaged) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 8;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 9;
              copy._oneofValidatorTypeValue = Validator_UnitType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 9) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 9) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 9;
            copy._oneofValidatorTypeValue = Validator_UnitType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitType.apply(type, path.slice(1), value);
          if (newValue === this.unitType) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 9;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "locationIsLane": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 10;
              copy._oneofValidatorTypeValue = Validator_LocationIsLane.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 10) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 10) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 10;
            copy._oneofValidatorTypeValue = Validator_LocationIsLane.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.locationIsLane.apply(type, path.slice(1), value);
          if (newValue === this.locationIsLane) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 10;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitAiBehavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 11;
              copy._oneofValidatorTypeValue = Validator_UnitAiBehavior.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 11) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 11) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 11;
            copy._oneofValidatorTypeValue = Validator_UnitAiBehavior.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAiBehavior.apply(type, path.slice(1), value);
          if (newValue === this.unitAiBehavior) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 11;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "waveStarted": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 12;
              copy._oneofValidatorTypeValue = Validator_WaveStarted.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 12) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 12) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 12;
            copy._oneofValidatorTypeValue = Validator_WaveStarted.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.waveStarted.apply(type, path.slice(1), value);
          if (newValue === this.waveStarted) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 12;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 13;
              copy._oneofValidatorTypeValue = Validator_UnitStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 13) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 13) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 13;
            copy._oneofValidatorTypeValue = Validator_UnitStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitStats.apply(type, path.slice(1), value);
          if (newValue === this.unitStats) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 13;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "pointOnNavmesh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 14;
              copy._oneofValidatorTypeValue = Validator_PointOnNavmesh.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 14) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 14) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 14;
            copy._oneofValidatorTypeValue = Validator_PointOnNavmesh.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.pointOnNavmesh.apply(type, path.slice(1), value);
          if (newValue === this.pointOnNavmesh) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 14;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "effectCriticalHit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 15;
              copy._oneofValidatorTypeValue = Validator_EffectCriticalHit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 15) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 15) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 15;
            copy._oneofValidatorTypeValue = Validator_EffectCriticalHit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.effectCriticalHit.apply(type, path.slice(1), value);
          if (newValue === this.effectCriticalHit) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 15;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "unitIsMoving": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 16;
              copy._oneofValidatorTypeValue = Validator_UnitIsMoving.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 16) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 16) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 16;
            copy._oneofValidatorTypeValue = Validator_UnitIsMoving.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitIsMoving.apply(type, path.slice(1), value);
          if (newValue === this.unitIsMoving) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 16;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "pointOnCliff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 17;
              copy._oneofValidatorTypeValue = Validator_PointOnCliff.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 17) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 17) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 17;
            copy._oneofValidatorTypeValue = Validator_PointOnCliff.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.pointOnCliff.apply(type, path.slice(1), value);
          if (newValue === this.pointOnCliff) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 17;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "expression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 101;
              copy._oneofValidatorTypeValue = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValidatorTypeCase !== 101) {
                return this;
              }
              const copy = new Validator(this);
              copy._oneofValidatorTypeCase = 0;
              copy._oneofValidatorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValidatorTypeCase !== 101) {
            const copy = new Validator(this);
            copy._oneofValidatorTypeCase = 101;
            copy._oneofValidatorTypeValue = dcei_engine_expression_proto.ValidatorExpressions.Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.expression.apply(type, path.slice(1), value);
          if (newValue === this.expression) {
            return this;
          }
          const copy = new Validator(this);
          copy._oneofValidatorTypeCase = 101;
          copy._oneofValidatorTypeValue = newValue;
          return copy;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Validator(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Validator(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Validator} other
   * @returns {Validator}
   */
  merge(other) {
    const copy = new Validator(this);
    if (other._hasNegate) {
      copy._hasNegate = true;
      copy._negate = other._negate;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._oneofValidatorTypeCase === 2) {
      if (this._oneofValidatorTypeCase === 2) {
        copy._oneofValidatorTypeValue = copy._oneofValidatorTypeValue.merge(other._oneofValidatorTypeValue);
      } else {
        copy._oneofValidatorTypeValue = other._oneofValidatorTypeValue;
      }
      copy._oneofValidatorTypeCase = 2;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    return copy;
  }
}
Validator.default = new Validator();
Validator.UnitWithinRange = Validator_UnitWithinRange;
Validator.NearbyUnitHealth = Validator_NearbyUnitHealth;
Validator.HealthValue = Validator_HealthValue;
Validator.TroopAmount = Validator_TroopAmount;
Validator.UnitFilter = Validator_UnitFilter;
Validator.UnitType = Validator_UnitType;
Validator.Combine = Validator_Combine;
Validator.UnitEngaged = Validator_UnitEngaged;
Validator.LocationIsLane = Validator_LocationIsLane;
Validator.UnitAiBehavior = Validator_UnitAiBehavior;
Validator.UnitStats = Validator_UnitStats;
Validator.PointOnNavmesh = Validator_PointOnNavmesh;
Validator.UnitIsMoving = Validator_UnitIsMoving;
Validator.EffectCriticalHit = Validator_EffectCriticalHit;
Validator.WaveStarted = Validator_WaveStarted;
Validator.PointOnCliff = Validator_PointOnCliff;
Validator.ValidatorValueType = Validator_ValidatorValueType;
class Validator_Builder {
  constructor(value) {
    this._value = new Validator(value);
  }
  build() {
    return new Validator(this._value);
  }
  setNegate(value) {
    this._value._hasNegate = true;
    this._value._negate = value;
    return this;
  }
  deleteNegate() {
    this._value._hasNegate = false;
    this._value._negate = null;
    return this;
  }
  clearoneofValidatorType() {
    this._value._oneofValidatorTypeCase = 0;
    this._value._oneofValidatorTypeValue = null;
    return this;
  }
  setUnitWithinRange(value) {
    this._value._oneofValidatorTypeCase = 2;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setNearbyUnitHealth(value) {
    this._value._oneofValidatorTypeCase = 3;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setHealthValue(value) {
    this._value._oneofValidatorTypeCase = 4;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setTroopAmount(value) {
    this._value._oneofValidatorTypeCase = 5;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitFilter(value) {
    this._value._oneofValidatorTypeCase = 6;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setCombine(value) {
    this._value._oneofValidatorTypeCase = 7;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitEngaged(value) {
    this._value._oneofValidatorTypeCase = 8;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitType(value) {
    this._value._oneofValidatorTypeCase = 9;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setLocationIsLane(value) {
    this._value._oneofValidatorTypeCase = 10;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitAiBehavior(value) {
    this._value._oneofValidatorTypeCase = 11;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setWaveStarted(value) {
    this._value._oneofValidatorTypeCase = 12;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitStats(value) {
    this._value._oneofValidatorTypeCase = 13;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setPointOnNavmesh(value) {
    this._value._oneofValidatorTypeCase = 14;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setEffectCriticalHit(value) {
    this._value._oneofValidatorTypeCase = 15;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setUnitIsMoving(value) {
    this._value._oneofValidatorTypeCase = 16;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setPointOnCliff(value) {
    this._value._oneofValidatorTypeCase = 17;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setExpression(value) {
    this._value._oneofValidatorTypeCase = 101;
    this._value._oneofValidatorTypeValue = value;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
}
Validator.Builder = Validator_Builder;
class Validator_WithParent {
  /**
   * @param {Validator} value
   * @param {Validator_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Validator.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasNegate() {
    if (this._cachedHasNegate === undefined) {
      if (this._value.hasNegate) {
        this._cachedHasNegate = true;
      } else {
        this._cachedHasNegate = this._parent ? this._parent.hasNegate : false;
      }
    }
    return this._cachedHasNegate;
  }
  get negate() {
    if (this._cachedNegate === undefined) {
      if (this._value.hasNegate) {
        this._cachedNegate = this._value.negate;
      } else {
        this._cachedNegate = this._parent ? this._parent.negate : this._value.negate;
      }
    }
    return this._cachedNegate;
  }
  get oneofValidatorTypeCase() {
    if (this._cachedoneofValidatorTypeCase === undefined) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedoneofValidatorTypeCase = this._parent ? this._parent.oneofValidatorTypeCase : 0;
      } else {
        this._cachedoneofValidatorTypeCase = this._value._oneofValidatorTypeCase;
      }
    }
    return this._cachedoneofValidatorTypeCase;
  }
  get unitWithinRange() {
    if (!this._cachedUnitWithinRange) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitWithinRange = this._parent ? new Validator_UnitWithinRange.WithParent(Validator_UnitWithinRange.default, this._parent.unitWithinRange) : this._value.unitWithinRange;
      } else if (this._value._oneofValidatorTypeCase === 2) {
        this._cachedUnitWithinRange = new Validator_UnitWithinRange.WithParent(this._value.unitWithinRange, this._parent && this._parent.oneofValidatorTypeCase === 2 ? this._parent.unitWithinRange : null);
      } else {
        this._cachedUnitWithinRange = Validator_UnitWithinRange.WithParent.default;
      }
    }
    return this._cachedUnitWithinRange;
  }
  get nearbyUnitHealth() {
    if (!this._cachedNearbyUnitHealth) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedNearbyUnitHealth = this._parent ? new Validator_NearbyUnitHealth.WithParent(Validator_NearbyUnitHealth.default, this._parent.nearbyUnitHealth) : this._value.nearbyUnitHealth;
      } else if (this._value._oneofValidatorTypeCase === 3) {
        this._cachedNearbyUnitHealth = new Validator_NearbyUnitHealth.WithParent(this._value.nearbyUnitHealth, this._parent && this._parent.oneofValidatorTypeCase === 3 ? this._parent.nearbyUnitHealth : null);
      } else {
        this._cachedNearbyUnitHealth = Validator_NearbyUnitHealth.WithParent.default;
      }
    }
    return this._cachedNearbyUnitHealth;
  }
  get healthValue() {
    if (!this._cachedHealthValue) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedHealthValue = this._parent ? new Validator_HealthValue.WithParent(Validator_HealthValue.default, this._parent.healthValue) : this._value.healthValue;
      } else if (this._value._oneofValidatorTypeCase === 4) {
        this._cachedHealthValue = new Validator_HealthValue.WithParent(this._value.healthValue, this._parent && this._parent.oneofValidatorTypeCase === 4 ? this._parent.healthValue : null);
      } else {
        this._cachedHealthValue = Validator_HealthValue.WithParent.default;
      }
    }
    return this._cachedHealthValue;
  }
  get troopAmount() {
    if (!this._cachedTroopAmount) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedTroopAmount = this._parent ? new Validator_TroopAmount.WithParent(Validator_TroopAmount.default, this._parent.troopAmount) : this._value.troopAmount;
      } else if (this._value._oneofValidatorTypeCase === 5) {
        this._cachedTroopAmount = new Validator_TroopAmount.WithParent(this._value.troopAmount, this._parent && this._parent.oneofValidatorTypeCase === 5 ? this._parent.troopAmount : null);
      } else {
        this._cachedTroopAmount = Validator_TroopAmount.WithParent.default;
      }
    }
    return this._cachedTroopAmount;
  }
  get unitFilter() {
    if (!this._cachedUnitFilter) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitFilter = this._parent ? new Validator_UnitFilter.WithParent(Validator_UnitFilter.default, this._parent.unitFilter) : this._value.unitFilter;
      } else if (this._value._oneofValidatorTypeCase === 6) {
        this._cachedUnitFilter = new Validator_UnitFilter.WithParent(this._value.unitFilter, this._parent && this._parent.oneofValidatorTypeCase === 6 ? this._parent.unitFilter : null);
      } else {
        this._cachedUnitFilter = Validator_UnitFilter.WithParent.default;
      }
    }
    return this._cachedUnitFilter;
  }
  get combine() {
    if (!this._cachedCombine) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedCombine = this._parent ? new Validator_Combine.WithParent(Validator_Combine.default, this._parent.combine) : this._value.combine;
      } else if (this._value._oneofValidatorTypeCase === 7) {
        this._cachedCombine = new Validator_Combine.WithParent(this._value.combine, this._parent && this._parent.oneofValidatorTypeCase === 7 ? this._parent.combine : null);
      } else {
        this._cachedCombine = Validator_Combine.WithParent.default;
      }
    }
    return this._cachedCombine;
  }
  get unitEngaged() {
    if (!this._cachedUnitEngaged) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitEngaged = this._parent ? new Validator_UnitEngaged.WithParent(Validator_UnitEngaged.default, this._parent.unitEngaged) : this._value.unitEngaged;
      } else if (this._value._oneofValidatorTypeCase === 8) {
        this._cachedUnitEngaged = new Validator_UnitEngaged.WithParent(this._value.unitEngaged, this._parent && this._parent.oneofValidatorTypeCase === 8 ? this._parent.unitEngaged : null);
      } else {
        this._cachedUnitEngaged = Validator_UnitEngaged.WithParent.default;
      }
    }
    return this._cachedUnitEngaged;
  }
  get unitType() {
    if (!this._cachedUnitType) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitType = this._parent ? new Validator_UnitType.WithParent(Validator_UnitType.default, this._parent.unitType) : this._value.unitType;
      } else if (this._value._oneofValidatorTypeCase === 9) {
        this._cachedUnitType = new Validator_UnitType.WithParent(this._value.unitType, this._parent && this._parent.oneofValidatorTypeCase === 9 ? this._parent.unitType : null);
      } else {
        this._cachedUnitType = Validator_UnitType.WithParent.default;
      }
    }
    return this._cachedUnitType;
  }
  get locationIsLane() {
    if (!this._cachedLocationIsLane) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedLocationIsLane = this._parent ? new Validator_LocationIsLane.WithParent(Validator_LocationIsLane.default, this._parent.locationIsLane) : this._value.locationIsLane;
      } else if (this._value._oneofValidatorTypeCase === 10) {
        this._cachedLocationIsLane = new Validator_LocationIsLane.WithParent(this._value.locationIsLane, this._parent && this._parent.oneofValidatorTypeCase === 10 ? this._parent.locationIsLane : null);
      } else {
        this._cachedLocationIsLane = Validator_LocationIsLane.WithParent.default;
      }
    }
    return this._cachedLocationIsLane;
  }
  get unitAiBehavior() {
    if (!this._cachedUnitAiBehavior) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitAiBehavior = this._parent ? new Validator_UnitAiBehavior.WithParent(Validator_UnitAiBehavior.default, this._parent.unitAiBehavior) : this._value.unitAiBehavior;
      } else if (this._value._oneofValidatorTypeCase === 11) {
        this._cachedUnitAiBehavior = new Validator_UnitAiBehavior.WithParent(this._value.unitAiBehavior, this._parent && this._parent.oneofValidatorTypeCase === 11 ? this._parent.unitAiBehavior : null);
      } else {
        this._cachedUnitAiBehavior = Validator_UnitAiBehavior.WithParent.default;
      }
    }
    return this._cachedUnitAiBehavior;
  }
  get waveStarted() {
    if (!this._cachedWaveStarted) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedWaveStarted = this._parent ? new Validator_WaveStarted.WithParent(Validator_WaveStarted.default, this._parent.waveStarted) : this._value.waveStarted;
      } else if (this._value._oneofValidatorTypeCase === 12) {
        this._cachedWaveStarted = new Validator_WaveStarted.WithParent(this._value.waveStarted, this._parent && this._parent.oneofValidatorTypeCase === 12 ? this._parent.waveStarted : null);
      } else {
        this._cachedWaveStarted = Validator_WaveStarted.WithParent.default;
      }
    }
    return this._cachedWaveStarted;
  }
  get unitStats() {
    if (!this._cachedUnitStats) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitStats = this._parent ? new Validator_UnitStats.WithParent(Validator_UnitStats.default, this._parent.unitStats) : this._value.unitStats;
      } else if (this._value._oneofValidatorTypeCase === 13) {
        this._cachedUnitStats = new Validator_UnitStats.WithParent(this._value.unitStats, this._parent && this._parent.oneofValidatorTypeCase === 13 ? this._parent.unitStats : null);
      } else {
        this._cachedUnitStats = Validator_UnitStats.WithParent.default;
      }
    }
    return this._cachedUnitStats;
  }
  get pointOnNavmesh() {
    if (!this._cachedPointOnNavmesh) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedPointOnNavmesh = this._parent ? new Validator_PointOnNavmesh.WithParent(Validator_PointOnNavmesh.default, this._parent.pointOnNavmesh) : this._value.pointOnNavmesh;
      } else if (this._value._oneofValidatorTypeCase === 14) {
        this._cachedPointOnNavmesh = new Validator_PointOnNavmesh.WithParent(this._value.pointOnNavmesh, this._parent && this._parent.oneofValidatorTypeCase === 14 ? this._parent.pointOnNavmesh : null);
      } else {
        this._cachedPointOnNavmesh = Validator_PointOnNavmesh.WithParent.default;
      }
    }
    return this._cachedPointOnNavmesh;
  }
  get effectCriticalHit() {
    if (!this._cachedEffectCriticalHit) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedEffectCriticalHit = this._parent ? new Validator_EffectCriticalHit.WithParent(Validator_EffectCriticalHit.default, this._parent.effectCriticalHit) : this._value.effectCriticalHit;
      } else if (this._value._oneofValidatorTypeCase === 15) {
        this._cachedEffectCriticalHit = new Validator_EffectCriticalHit.WithParent(this._value.effectCriticalHit, this._parent && this._parent.oneofValidatorTypeCase === 15 ? this._parent.effectCriticalHit : null);
      } else {
        this._cachedEffectCriticalHit = Validator_EffectCriticalHit.WithParent.default;
      }
    }
    return this._cachedEffectCriticalHit;
  }
  get unitIsMoving() {
    if (!this._cachedUnitIsMoving) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedUnitIsMoving = this._parent ? new Validator_UnitIsMoving.WithParent(Validator_UnitIsMoving.default, this._parent.unitIsMoving) : this._value.unitIsMoving;
      } else if (this._value._oneofValidatorTypeCase === 16) {
        this._cachedUnitIsMoving = new Validator_UnitIsMoving.WithParent(this._value.unitIsMoving, this._parent && this._parent.oneofValidatorTypeCase === 16 ? this._parent.unitIsMoving : null);
      } else {
        this._cachedUnitIsMoving = Validator_UnitIsMoving.WithParent.default;
      }
    }
    return this._cachedUnitIsMoving;
  }
  get pointOnCliff() {
    if (!this._cachedPointOnCliff) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedPointOnCliff = this._parent ? new Validator_PointOnCliff.WithParent(Validator_PointOnCliff.default, this._parent.pointOnCliff) : this._value.pointOnCliff;
      } else if (this._value._oneofValidatorTypeCase === 17) {
        this._cachedPointOnCliff = new Validator_PointOnCliff.WithParent(this._value.pointOnCliff, this._parent && this._parent.oneofValidatorTypeCase === 17 ? this._parent.pointOnCliff : null);
      } else {
        this._cachedPointOnCliff = Validator_PointOnCliff.WithParent.default;
      }
    }
    return this._cachedPointOnCliff;
  }
  get expression() {
    if (!this._cachedExpression) {
      if (this._value._oneofValidatorTypeCase === 0) {
        this._cachedExpression = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(dcei_engine_expression_proto.ValidatorExpressions.Expression.default, this._parent.expression) : this._value.expression;
      } else if (this._value._oneofValidatorTypeCase === 101) {
        this._cachedExpression = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(this._value.expression, this._parent && this._parent.oneofValidatorTypeCase === 101 ? this._parent.expression : null);
      } else {
        this._cachedExpression = dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent.default;
      }
    }
    return this._cachedExpression;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  update(current, parent) {
    const result = new Validator_WithParent(current, parent);
    if (this._cachedUnitWithinRange && this._value._oneofValidatorTypeCase === 2 && current._oneofValidatorTypeCase === 2) {
      if (this._value.unitWithinRange === current.unitWithinRange && this._parent === parent) {
        result._cachedUnitWithinRange = this._cachedUnitWithinRange;
      } else {
        result._cachedUnitWithinRange = this._cachedUnitWithinRange.update(current.unitWithinRange, parent && parent.oneofValidatorTypeCase === 2 ? parent.unitWithinRange : null);
      }
    }
    if (this._cachedNearbyUnitHealth && this._value._oneofValidatorTypeCase === 3 && current._oneofValidatorTypeCase === 3) {
      if (this._value.nearbyUnitHealth === current.nearbyUnitHealth && this._parent === parent) {
        result._cachedNearbyUnitHealth = this._cachedNearbyUnitHealth;
      } else {
        result._cachedNearbyUnitHealth = this._cachedNearbyUnitHealth.update(current.nearbyUnitHealth, parent && parent.oneofValidatorTypeCase === 3 ? parent.nearbyUnitHealth : null);
      }
    }
    if (this._cachedHealthValue && this._value._oneofValidatorTypeCase === 4 && current._oneofValidatorTypeCase === 4) {
      if (this._value.healthValue === current.healthValue && this._parent === parent) {
        result._cachedHealthValue = this._cachedHealthValue;
      } else {
        result._cachedHealthValue = this._cachedHealthValue.update(current.healthValue, parent && parent.oneofValidatorTypeCase === 4 ? parent.healthValue : null);
      }
    }
    if (this._cachedTroopAmount && this._value._oneofValidatorTypeCase === 5 && current._oneofValidatorTypeCase === 5) {
      if (this._value.troopAmount === current.troopAmount && this._parent === parent) {
        result._cachedTroopAmount = this._cachedTroopAmount;
      } else {
        result._cachedTroopAmount = this._cachedTroopAmount.update(current.troopAmount, parent && parent.oneofValidatorTypeCase === 5 ? parent.troopAmount : null);
      }
    }
    if (this._cachedUnitFilter && this._value._oneofValidatorTypeCase === 6 && current._oneofValidatorTypeCase === 6) {
      if (this._value.unitFilter === current.unitFilter && this._parent === parent) {
        result._cachedUnitFilter = this._cachedUnitFilter;
      } else {
        result._cachedUnitFilter = this._cachedUnitFilter.update(current.unitFilter, parent && parent.oneofValidatorTypeCase === 6 ? parent.unitFilter : null);
      }
    }
    if (this._cachedCombine && this._value._oneofValidatorTypeCase === 7 && current._oneofValidatorTypeCase === 7) {
      if (this._value.combine === current.combine && this._parent === parent) {
        result._cachedCombine = this._cachedCombine;
      } else {
        result._cachedCombine = this._cachedCombine.update(current.combine, parent && parent.oneofValidatorTypeCase === 7 ? parent.combine : null);
      }
    }
    if (this._cachedUnitEngaged && this._value._oneofValidatorTypeCase === 8 && current._oneofValidatorTypeCase === 8) {
      if (this._value.unitEngaged === current.unitEngaged && this._parent === parent) {
        result._cachedUnitEngaged = this._cachedUnitEngaged;
      } else {
        result._cachedUnitEngaged = this._cachedUnitEngaged.update(current.unitEngaged, parent && parent.oneofValidatorTypeCase === 8 ? parent.unitEngaged : null);
      }
    }
    if (this._cachedUnitType && this._value._oneofValidatorTypeCase === 9 && current._oneofValidatorTypeCase === 9) {
      if (this._value.unitType === current.unitType && this._parent === parent) {
        result._cachedUnitType = this._cachedUnitType;
      } else {
        result._cachedUnitType = this._cachedUnitType.update(current.unitType, parent && parent.oneofValidatorTypeCase === 9 ? parent.unitType : null);
      }
    }
    if (this._cachedLocationIsLane && this._value._oneofValidatorTypeCase === 10 && current._oneofValidatorTypeCase === 10) {
      if (this._value.locationIsLane === current.locationIsLane && this._parent === parent) {
        result._cachedLocationIsLane = this._cachedLocationIsLane;
      } else {
        result._cachedLocationIsLane = this._cachedLocationIsLane.update(current.locationIsLane, parent && parent.oneofValidatorTypeCase === 10 ? parent.locationIsLane : null);
      }
    }
    if (this._cachedUnitAiBehavior && this._value._oneofValidatorTypeCase === 11 && current._oneofValidatorTypeCase === 11) {
      if (this._value.unitAiBehavior === current.unitAiBehavior && this._parent === parent) {
        result._cachedUnitAiBehavior = this._cachedUnitAiBehavior;
      } else {
        result._cachedUnitAiBehavior = this._cachedUnitAiBehavior.update(current.unitAiBehavior, parent && parent.oneofValidatorTypeCase === 11 ? parent.unitAiBehavior : null);
      }
    }
    if (this._cachedWaveStarted && this._value._oneofValidatorTypeCase === 12 && current._oneofValidatorTypeCase === 12) {
      if (this._value.waveStarted === current.waveStarted && this._parent === parent) {
        result._cachedWaveStarted = this._cachedWaveStarted;
      } else {
        result._cachedWaveStarted = this._cachedWaveStarted.update(current.waveStarted, parent && parent.oneofValidatorTypeCase === 12 ? parent.waveStarted : null);
      }
    }
    if (this._cachedUnitStats && this._value._oneofValidatorTypeCase === 13 && current._oneofValidatorTypeCase === 13) {
      if (this._value.unitStats === current.unitStats && this._parent === parent) {
        result._cachedUnitStats = this._cachedUnitStats;
      } else {
        result._cachedUnitStats = this._cachedUnitStats.update(current.unitStats, parent && parent.oneofValidatorTypeCase === 13 ? parent.unitStats : null);
      }
    }
    if (this._cachedPointOnNavmesh && this._value._oneofValidatorTypeCase === 14 && current._oneofValidatorTypeCase === 14) {
      if (this._value.pointOnNavmesh === current.pointOnNavmesh && this._parent === parent) {
        result._cachedPointOnNavmesh = this._cachedPointOnNavmesh;
      } else {
        result._cachedPointOnNavmesh = this._cachedPointOnNavmesh.update(current.pointOnNavmesh, parent && parent.oneofValidatorTypeCase === 14 ? parent.pointOnNavmesh : null);
      }
    }
    if (this._cachedEffectCriticalHit && this._value._oneofValidatorTypeCase === 15 && current._oneofValidatorTypeCase === 15) {
      if (this._value.effectCriticalHit === current.effectCriticalHit && this._parent === parent) {
        result._cachedEffectCriticalHit = this._cachedEffectCriticalHit;
      } else {
        result._cachedEffectCriticalHit = this._cachedEffectCriticalHit.update(current.effectCriticalHit, parent && parent.oneofValidatorTypeCase === 15 ? parent.effectCriticalHit : null);
      }
    }
    if (this._cachedUnitIsMoving && this._value._oneofValidatorTypeCase === 16 && current._oneofValidatorTypeCase === 16) {
      if (this._value.unitIsMoving === current.unitIsMoving && this._parent === parent) {
        result._cachedUnitIsMoving = this._cachedUnitIsMoving;
      } else {
        result._cachedUnitIsMoving = this._cachedUnitIsMoving.update(current.unitIsMoving, parent && parent.oneofValidatorTypeCase === 16 ? parent.unitIsMoving : null);
      }
    }
    if (this._cachedPointOnCliff && this._value._oneofValidatorTypeCase === 17 && current._oneofValidatorTypeCase === 17) {
      if (this._value.pointOnCliff === current.pointOnCliff && this._parent === parent) {
        result._cachedPointOnCliff = this._cachedPointOnCliff;
      } else {
        result._cachedPointOnCliff = this._cachedPointOnCliff.update(current.pointOnCliff, parent && parent.oneofValidatorTypeCase === 17 ? parent.pointOnCliff : null);
      }
    }
    if (this._cachedExpression && this._value._oneofValidatorTypeCase === 101 && current._oneofValidatorTypeCase === 101) {
      if (this._value.expression === current.expression && this._parent === parent) {
        result._cachedExpression = this._cachedExpression;
      } else {
        result._cachedExpression = this._cachedExpression.update(current.expression, parent && parent.oneofValidatorTypeCase === 101 ? parent.expression : null);
      }
    }
    return result;
  }
}
Validator_WithParent.default = new Validator_WithParent(Validator.default, null);
Validator.WithParent = Validator_WithParent;
class Validator_Descriptor {
  get negate() {
    if (!this._negate) {
      this._negate = {
        name: "negate",
        Name: "Negate",
        number: 1,
        protoType: 8,
        protoName: "negate",
        type: JsonToBoolean,
        options: {
          comments: "Flips the result of the validator, similar to the `not` in Lua (true becomes false, false becomes true).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._negate;
  }
  get unitWithinRange() {
    if (!this._unitWithinRange) {
      this._unitWithinRange = {
        name: "unitWithinRange",
        Name: "UnitWithinRange",
        number: 2,
        protoType: 11,
        protoName: "unit_within_range",
        oneofIndex: 1,
        type: Validator_UnitWithinRange,
        options: {
          comments: "Returns true if the specified number of units are found within a search radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWithinRange;
  }
  get nearbyUnitHealth() {
    if (!this._nearbyUnitHealth) {
      this._nearbyUnitHealth = {
        name: "nearbyUnitHealth",
        Name: "NearbyUnitHealth",
        number: 3,
        protoType: 11,
        protoName: "nearby_unit_health",
        oneofIndex: 1,
        type: Validator_NearbyUnitHealth,
        options: {
          comments: "Returns true if a number of units are found within a search radius with a specific health value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nearbyUnitHealth;
  }
  get healthValue() {
    if (!this._healthValue) {
      this._healthValue = {
        name: "healthValue",
        Name: "HealthValue",
        number: 4,
        protoType: 11,
        protoName: "health_value",
        oneofIndex: 1,
        type: Validator_HealthValue,
        options: {
          comments: "Returns true if a unit has health within a specific range.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthValue;
  }
  get troopAmount() {
    if (!this._troopAmount) {
      this._troopAmount = {
        name: "troopAmount",
        Name: "TroopAmount",
        number: 5,
        protoType: 11,
        protoName: "troop_amount",
        oneofIndex: 1,
        type: Validator_TroopAmount,
        options: {
          comments: "Returns true of the unit has a specified number of child troop units.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._troopAmount;
  }
  get unitFilter() {
    if (!this._unitFilter) {
      this._unitFilter = {
        name: "unitFilter",
        Name: "UnitFilter",
        number: 6,
        protoType: 11,
        protoName: "unit_filter",
        oneofIndex: 1,
        type: Validator_UnitFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitFilter;
  }
  get combine() {
    if (!this._combine) {
      this._combine = {
        name: "combine",
        Name: "Combine",
        number: 7,
        protoType: 11,
        protoName: "combine",
        oneofIndex: 1,
        type: Validator_Combine,
        options: {
          comments: "Allows you to combine other validators using logical operators.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._combine;
  }
  get unitEngaged() {
    if (!this._unitEngaged) {
      this._unitEngaged = {
        name: "unitEngaged",
        Name: "UnitEngaged",
        number: 8,
        protoType: 11,
        protoName: "unit_engaged",
        oneofIndex: 1,
        type: Validator_UnitEngaged,
        options: {
          comments: "Returns true if the specified unit is engaged.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitEngaged;
  }
  get unitType() {
    if (!this._unitType) {
      this._unitType = {
        name: "unitType",
        Name: "UnitType",
        number: 9,
        protoType: 11,
        protoName: "unit_type",
        oneofIndex: 1,
        type: Validator_UnitType,
        options: {
          comments: "Returns true if a unit is of a specific type.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitType;
  }
  get locationIsLane() {
    if (!this._locationIsLane) {
      this._locationIsLane = {
        name: "locationIsLane",
        Name: "LocationIsLane",
        number: 10,
        protoType: 11,
        protoName: "location_is_lane",
        oneofIndex: 1,
        type: Validator_LocationIsLane,
        options: {
          comments: "Returns true if a point is in a lane (as defined in Terrain/WayPoints/Routes).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._locationIsLane;
  }
  get unitAiBehavior() {
    if (!this._unitAiBehavior) {
      this._unitAiBehavior = {
        name: "unitAiBehavior",
        Name: "UnitAiBehavior",
        number: 11,
        protoType: 11,
        protoName: "unit_ai_behavior",
        oneofIndex: 1,
        type: Validator_UnitAiBehavior,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAiBehavior;
  }
  get waveStarted() {
    if (!this._waveStarted) {
      this._waveStarted = {
        name: "waveStarted",
        Name: "WaveStarted",
        number: 12,
        protoType: 11,
        protoName: "wave_started",
        oneofIndex: 1,
        type: Validator_WaveStarted,
        options: {
          comments: "Returns true if the first wave has started.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waveStarted;
  }
  get unitStats() {
    if (!this._unitStats) {
      this._unitStats = {
        name: "unitStats",
        Name: "UnitStats",
        number: 13,
        protoType: 11,
        protoName: "unit_stats",
        oneofIndex: 1,
        type: Validator_UnitStats,
        options: {
          comments: "Returns true if a unit matches the specified unit filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitStats;
  }
  get pointOnNavmesh() {
    if (!this._pointOnNavmesh) {
      this._pointOnNavmesh = {
        name: "pointOnNavmesh",
        Name: "PointOnNavmesh",
        number: 14,
        protoType: 11,
        protoName: "point_on_navmesh",
        oneofIndex: 1,
        type: Validator_PointOnNavmesh,
        options: {
          comments: "Returns true if a point is on the nav mesh.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pointOnNavmesh;
  }
  get effectCriticalHit() {
    if (!this._effectCriticalHit) {
      this._effectCriticalHit = {
        name: "effectCriticalHit",
        Name: "EffectCriticalHit",
        number: 15,
        protoType: 11,
        protoName: "effect_critical_hit",
        oneofIndex: 1,
        type: Validator_EffectCriticalHit,
        options: {
          comments: "Returns true if the effect tree is a critical hit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectCriticalHit;
  }
  get unitIsMoving() {
    if (!this._unitIsMoving) {
      this._unitIsMoving = {
        name: "unitIsMoving",
        Name: "UnitIsMoving",
        number: 16,
        protoType: 11,
        protoName: "unit_is_moving",
        oneofIndex: 1,
        type: Validator_UnitIsMoving,
        options: {
          comments: "Returns true if a unit is currently moving.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitIsMoving;
  }
  get pointOnCliff() {
    if (!this._pointOnCliff) {
      this._pointOnCliff = {
        name: "pointOnCliff",
        Name: "PointOnCliff",
        number: 17,
        protoType: 11,
        protoName: "point_on_cliff",
        oneofIndex: 1,
        type: Validator_PointOnCliff,
        options: {
          comments: "Returns true if a point is on the cliff.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pointOnCliff;
  }
  get expression() {
    if (!this._expression) {
      this._expression = {
        name: "expression",
        Name: "Expression",
        number: 101,
        protoType: 11,
        protoName: "expression",
        oneofIndex: 1,
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expression;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.negate,
        this.unitWithinRange,
        this.nearbyUnitHealth,
        this.healthValue,
        this.troopAmount,
        this.unitFilter,
        this.combine,
        this.unitEngaged,
        this.unitType,
        this.locationIsLane,
        this.unitAiBehavior,
        this.waveStarted,
        this.unitStats,
        this.pointOnNavmesh,
        this.effectCriticalHit,
        this.unitIsMoving,
        this.pointOnCliff,
        this.expression,
        this.comment,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForNegate",
        Name: "DummyOneofForNegate",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "oneofValidatorType",
        Name: "OneofValidatorType",
        fields: [
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[18],
        ],
      });
    }
    return this._oneofs;
  }
}
Validator.descriptor = new Validator_Descriptor();
